(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["period-shop-menstrual-cup-troubleshooter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const paths = {
      leaking: '/blogs/all/why-is-my-menstrual-cup-leaking',
      hurting: '/blogs/all/what-to-do-if-your-menstrual-cup-is-hurting',
      slipping: '/blogs/all/5-reasons-why-your-menstrual-cup-is-slipping-down',
      opening: '/blogs/all/troubleshooting-tips-what-to-try-if-you-cant-get-your-menstrual-cup-to-open',
      stuck: '/blogs/all/what-to-do-if-your-menstrual-cup-is-stuck',
      howTo: '/blogs/all/how-to-use-a-menstrual-cup',
      beginner: '/blogs/all/a-beginners-guide-to-using-a-menstrual-cup-tips-for-a-smooth-start',
      folds: '/blogs/all/a-guide-to-different-menstrual-cup-folds',
      dryRun: '/blogs/all/how-to-do-a-dry-run-with-a-menstrual-cup-or-disc',
      stains: '/blogs/all/how-to-remove-menstrual-cup-stains',
      lifespan: '/blogs/all/what-is-the-lifespan-of-a-menstrual-cup-or-disc',
      wear: '/blogs/all/how-long-can-you-wear-a-menstrual-cup-for',
      safety: '/blogs/all/are-menstrual-cups-safe-what-the-science-says',
      firmness: '/blogs/all/should-you-choose-a-soft-or-firm-menstrual-cup',
      cervix: '/blogs/all/how-to-measure-your-cervical-position',
      shapes: '/blogs/all/menstrual-cup-shapes-guide',
      comparison: '/blogs/all/menstrual-cups-comparison-chart',
      iud: '/blogs/all/using-menstrual-cups-or-discs-with-iuds',
      quiz: '/pages/quiz',
      physio: '/pages/find-a-pelvic-health-physiotherapist',
      contact: '/pages/contact-us'
    };

    const choice = (label, next, detail = '') => ({ label, next, detail });
    const question = (title, copy, choices) => ({ title, copy, choices });
    const link = (label, url) => ({ label, url });
    const result = (title, summary, why, steps, tags, primary, secondary = null, note = '', medical = false, kicker = 'Your result') => ({
      title, summary, why, steps, tags, primary, secondary, note, medical, kicker
    });

    const questions = {
      issue: question('What are you having trouble with?', 'Choose the problem that best matches what is happening now.', [
        choice('My cup is leaking', 'leak_when', 'Spotting, ongoing leaks or overflow'),
        choice('My cup will not open', 'open_state', 'The rim or body stays folded or dented'),
        choice('My cup is slipping down', 'slip_where', 'It moves towards the vaginal opening'),
        choice('I am having trouble inserting it', 'insert_problem', 'Friction, folding, angle or muscle tension'),
        choice('I am having trouble removing it', 'remove_problem', 'It feels stuck, high or painful to remove'),
        choice('It causes pain or pressure', 'pain_when', 'During insertion, wear, urination or removal'),
        choice('The stem is bothering me', 'stem_fit', 'Rubbing, poking or difficult to reach'),
        choice('I have a cleaning or cup-care question', 'care_problem', 'Stains, odour, holes, damage or wear time'),
        choice('I am new and not sure what is wrong', 'r:beginner'),
        choice('My problem is not listed', 'r:contact')
      ]),

      leak_when: question('When does the leaking happen?', 'Timing is one of the most useful clues.', [
        choice('Only a few spots soon after insertion', 'r:residual'),
        choice('Almost immediately or within an hour', 'leak_full_early'),
        choice('After several hours', 'leak_full_later'),
        choice('Mostly during exercise or movement', 'leak_movement'),
        choice('I am not sure', 'r:observe_leak')
      ]),

      leak_full_early: question('How full is the cup when you remove it?', 'Check this before changing your cup or technique.', [
        choice('Empty or only a little fluid', 'leak_open'),
        choice('Nearly full or overflowing', 'r:overflow'),
        choice('I have not checked', 'r:observe_leak')
      ]),

      leak_full_later: question('How full is the cup when leaking begins?', 'The collected amount matters more than the advertised capacity.', [
        choice('Full or nearly full', 'r:overflow'),
        choice('Partly full', 'leak_open'),
        choice('Mostly empty', 'leak_cervix'),
        choice('I have not checked', 'r:observe_leak')
      ]),

      leak_open: question('Does the cup feel completely open?', 'Run a clean finger around the cup body and as much of the rim as you can comfortably reach.', [
        choice('I can feel a dent or fold', 'r:not_open'),
        choice('It feels fully open', 'leak_cervix'),
        choice('I cannot tell', 'r:not_open')
      ]),

      leak_cervix: question('Have you checked that your cervix is above or inside the cup?', 'A cup can open normally while the cervix sits beside the rim.', [
        choice('No or I am not sure', 'r:cervix_outside'),
        choice('Yes, the cervix is inside the cup', 'leak_condition')
      ]),

      leak_condition: question('Are the air holes clear and is the cup undamaged?', 'Inspect it in good light before using it again.', [
        choice('A hole is blocked', 'r:blocked_holes'),
        choice('It is cracked, torn, sticky or damaged', 'r:replace_cup'),
        choice('It is clean, open and undamaged', 'r:leak_fit')
      ]),

      leak_movement: question('Does it work properly when you are not exercising?', 'Movement-specific leaking can point to a fit or firmness issue.', [
        choice('Yes, it leaks mainly when I am active', 'r:activity_leak'),
        choice('No, it leaks at other times too', 'leak_full_early'),
        choice('It is full when it leaks', 'r:overflow')
      ]),

      open_state: question('What happens after you insert it?', 'A cup does not need to make a popping sound, but the body and rim should not remain folded.', [
        choice('The rim or body stays dented', 'open_firmness'),
        choice('It opens and then collapses during wear', 'r:open_collapses'),
        choice('It opens before it is fully inserted', 'r:opens_early'),
        choice('I cannot tell whether it is open', 'r:opening_basics')
      ]),

      open_firmness: question('How would you describe the cup?', 'If you are unsure, check its product page or the Period Shop comparison chart.', [
        choice('Soft and easy to squash', 'r:open_soft'),
        choice('Average or firm', 'r:open_position'),
        choice('I do not know', 'r:opening_basics')
      ]),

      slip_where: question('What is actually moving down?', 'This separates stem irritation from a cup that is descending.', [
        choice('Only the stem feels low or pokes out', 'stem_fit'),
        choice('The cup body moves towards the opening', 'slip_full'),
        choice('It shifts mainly when I use the toilet', 'r:slip_toilet'),
        choice('I am not sure', 'slip_full')
      ]),

      slip_full: question('Is the cup full when it slips?', 'The added weight of a full cup can make an otherwise suitable cup move lower.', [
        choice('Yes or nearly full', 'r:overflow_slip'),
        choice('No, it is empty or partly full', 'slip_cervix'),
        choice('I have not checked', 'r:observe_slip')
      ]),

      slip_cervix: question('Where is your cervix during your period?', 'Measure during your period because cervical position can change.', [
        choice('Low, and the cup body sits close to the opening', 'r:cup_too_long'),
        choice('Average or high', 'r:slip_fit'),
        choice('I do not know', 'r:check_cervix')
      ]),

      insert_problem: question('What makes insertion difficult?', 'Do not force a cup through pain or strong resistance.', [
        choice('Friction, dryness, burning or stinging', 'insert_other'),
        choice('The folded cup feels too wide', 'r:narrow_fold'),
        choice('The cup opens too early', 'r:opens_early'),
        choice('I cannot find the right angle', 'r:insert_angle'),
        choice('My muscles tighten or I cannot insert it', 'insert_other')
      ]),

      insert_other: question('Is other vaginal insertion also painful or difficult?', 'Think about tampons, a clean finger, penetrative sex or a pelvic examination.', [
        choice('Yes, other insertion is also painful or difficult', 'r:persistent_insertion_pain'),
        choice('No, it seems specific to this cup', 'r:cup_insertion'),
        choice('I am not sure', 'r:gentle_trial')
      ]),

      remove_problem: question('Which removal problem best matches?', 'The stem is a guide. Do not pull forcefully without first releasing the seal.', [
        choice('The cup is stuck right now', 'remove_safety'),
        choice('The cup moves too high for me to reach', 'r:high_removal'),
        choice('Releasing the seal is painful or difficult', 'r:release_seal'),
        choice('It hurts as the rim comes out', 'r:refold_removal'),
        choice('Removal is generally awkward', 'r:removal_basics')
      ]),

      remove_safety: question('Are you in severe pain or feeling unwell?', 'This determines whether self-help steps are appropriate.', [
        choice('Yes, or I have fever, vomiting, dizziness, rash or cannot urinate', 'r:urgent_help'),
        choice('No, I feel well but cannot remove it', 'r:stuck_calm')
      ]),

      pain_when: question('When do you feel the pain or pressure?', 'Remove the cup if discomfort is significant, worsening or does not settle after repositioning.', [
        choice('During insertion', 'insert_other'),
        choice('While the cup is in place', 'pain_type'),
        choice('During removal', 'remove_problem'),
        choice('When urinating or having a bowel movement', 'r:bladder_bowel'),
        choice('New pain with an IUD or my strings feel different', 'r:iud_concern')
      ]),

      pain_type: question('Where do you notice it most?', 'The location and type of discomfort can point to different fit factors.', [
        choice('At the vaginal opening or from the stem', 'stem_fit'),
        choice('Bladder pressure, urgency or a slower urine stream', 'r:bladder_pressure'),
        choice('Deep cramps, aching or pressure near the cervix', 'r:deep_pain'),
        choice('General internal pressure or fullness', 'r:wear_pressure')
      ]),

      stem_fit: question('Does the cup body itself feel comfortable?', 'Check this before trimming anything.', [
        choice('Yes, only the stem rubs or pokes', 'r:stem_trim'),
        choice('No, the cup body also feels low or crowded', 'r:cup_too_long'),
        choice('The stem is difficult to reach', 'r:high_removal')
      ]),

      care_problem: question('What would you like help with?', 'Inspect your cup regularly and follow its own care instructions.', [
        choice('Staining or discolouration', 'r:stains'),
        choice('An odour that remains after cleaning', 'r:odour'),
        choice('Blocked air holes', 'r:blocked_holes'),
        choice('Cracks, tears, stickiness, powderiness or damage', 'r:replace_cup'),
        choice('Wear time or routine cleaning', 'r:wear_cleaning')
      ])
    };

    const results = {
      residual: result(
        'This may be residual blood rather than an ongoing leak',
        'A small amount of blood can remain on the vaginal walls below the cup after insertion and appear as a few spots even when the cup is collecting normally.',
        'If the spotting stops and the cup contains fluid when removed, the cup may be working correctly.',
        [
          'After inserting the cup, wipe away any blood below it with clean toilet paper or a damp cloth.',
          'Use backup protection while testing if that helps you feel more confident.',
          'If the spotting becomes an ongoing flow, restart the tool and choose the timing that best matches.'
        ],
        ['Technique check', 'No new cup yet'],
        link('Read the leaking guide', paths.leaking),
        null,
        '',
        false,
        'Most likely'
      ),

      overflow: result(
        'The cup is probably reaching its usable capacity',
        'A cup that starts leaking when it is full or nearly full is more likely overflowing than fitting incorrectly.',
        'Usable capacity may be lower than the advertised amount when the cervix sits inside the cup and takes up space.',
        [
          'Empty the cup sooner and note how long it takes to fill on heavier days.',
          'Check whether your cervix sits inside the cup and reduces the space available for fluid.',
          'If frequent emptying is impractical, compare usable capacity alongside length, diameter and comfort.'
        ],
        ['Capacity', 'Empty sooner', 'Heavy-flow check'],
        link('Read the leaking guide', paths.leaking),
        link('Compare cup capacity', paths.comparison),
        'If you repeatedly fill a cup very quickly, bleed through protection or feel dizzy, breathless or unusually fatigued, speak with a healthcare professional about the bleeding.',
        true,
        'Most likely'
      ),

      observe_leak: result(
        'Check the cup before changing anything',
        'The most useful clues are when leaking begins, whether the cup is open and how full it is when removed.',
        'Changing several things at once makes it harder to identify residual blood, positioning, opening, capacity or fit.',
        [
          'Use backup protection for one wear test.',
          'Note the insertion time and when leaking begins.',
          'On removal, check fullness and whether the cup has dents or folds.',
          'Restart this tool with those details.'
        ],
        ['Observe first', 'One change at a time'],
        link('Read the leaking guide', paths.leaking),
        null,
        '',
        false,
        'Best next step'
      ),

      not_open: result(
        'The cup may not be fully open',
        'A dented or folded cup may not form stable contact around the vaginal walls.',
        'Softness, limited space, insertion height, the fold and pelvic-floor tension can all affect opening.',
        [
          'Try letting the cup open slightly lower or higher than usual.',
          'Run a clean finger around the body and press the vaginal wall gently away from the dent.',
          'Press the base opposite the dent or gently wiggle the cup. A popping sound is not required.',
          'If it repeatedly stays folded, compare the opening tips for soft and firmer cups.'
        ],
        ['Opening technique', 'Position', 'Firmness'],
        link('Try the opening guide', paths.opening),
        link('Compare cup firmness', paths.firmness),
        '',
        false,
        'Most likely'
      ),

      cervix_outside: result(
        'Your cervix may be sitting beside the cup',
        'A cup can feel open but leak when the cervix sits outside the rim.',
        'The vaginal canal is not a straight vertical tube, and the cervix can sit off-centre or move during your period.',
        [
          'Locate your cervix with a clean finger during your period.',
          'Aim the folded cup towards the cervix rather than straight upwards.',
          'After opening, trace the rim and check that you cannot feel the cervix beside it.',
          'If it is difficult to position, compare cup shape and diameter rather than automatically choosing a larger size.'
        ],
        ['Cervix position', 'Insertion angle', 'Shape'],
        link('Learn to locate your cervix', paths.cervix),
        link('Read the leaking guide', paths.leaking),
        '',
        false,
        'Possible cause'
      ),

      leak_fit: result(
        'The cup may not be maintaining a reliable fit',
        'If it is open, correctly positioned, not full and undamaged, its diameter, shape or firmness may not work well with your anatomy and movement.',
        'A cup can be the labelled “right size” but still be the wrong shape, width or firmness for an individual body.',
        [
          'Repeat one careful wear test to confirm that the cup is open and the cervix is inside it.',
          'Note whether the cup changes shape, rotates, descends or leaks only during particular activities.',
          'Compare your cup with alternatives by diameter, shape and firmness.',
          'Change one characteristic only when the pattern points to it.'
        ],
        ['Diameter', 'Shape', 'Firmness'],
        link('Compare cup specifications', paths.comparison),
        link('Take the Best Fit Quiz', paths.quiz),
        '',
        false,
        'Possible cause'
      ),

      activity_leak: result(
        'Movement may be changing the cup’s shape or position',
        'A cup that works during ordinary wear but leaks during exercise may flex, shift or lose stable contact when pressure changes.',
        'The answer is not always the firmest cup. Shape, diameter, firmness and comfort need to work together.',
        [
          'Confirm the cup is open and not close to full before exercise.',
          'Notice whether it descends, becomes dented or leaks only with particular movements.',
          'If it collapses, a somewhat firmer cup may help. If it shifts without collapsing, review diameter and shape too.',
          'Stop if a firmer cup causes bladder pressure, pain or difficulty urinating.'
        ],
        ['Active use', 'Firmness', 'Shape and diameter'],
        link('Read the leaking guide', paths.leaking),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'Possible cause'
      ),

      blocked_holes: result(
        'Clear the air holes before using the cup again',
        'Blocked holes may affect how some cup designs open or release during removal.',
        'Dried fluid or cleaning residue can be difficult to see, so inspect each hole in good light.',
        [
          'Clean the cup according to the manufacturer’s instructions.',
          'Gently flex the rim and flush each hole with water. Do not enlarge it or use anything sharp.',
          'Inspect the cup for tears or damage around the holes.',
          'If a hole remains blocked or damaged, contact the manufacturer before using it again.'
        ],
        ['Cup care', 'Air holes', 'Inspect for damage'],
        link('Read the cup safety guide', paths.safety),
        null,
        '',
        false,
        'Practical check'
      ),

      replace_cup: result(
        'The cup may be deteriorating or damaged',
        'Cracks, tears, a tacky or powdery surface, permanent deformation or damage around the holes are reasons to stop using it.',
        'Damage can make a cup harder to clean and may affect performance or comfort.',
        [
          'Stop using the cup and check the manufacturer’s replacement guidance.',
          'Do not cut, glue, enlarge holes or attempt to repair it.',
          'Review whether cleaning, storage or age may have contributed.',
          'If it otherwise fitted well, compare replacements with similar dimensions and features.'
        ],
        ['Replace', 'Material condition', 'Do not repair'],
        link('Check cup lifespan guidance', paths.lifespan),
        link('Compare replacement cups', paths.comparison),
        '',
        false,
        'Stop using this cup'
      ),

      open_soft: result(
        'Give the softer cup more room to open',
        'Softer cups can be comfortable but may need more deliberate opening technique.',
        'A softer body is more easily held in a folded position by surrounding muscles or limited space.',
        [
          'Try a fold with a clear release point, such as a punch-down fold.',
          'Let the cup open slightly lower, then guide it into position.',
          'Press the vaginal wall away from the dent or press the cup base opposite it.',
          'If it repeatedly collapses during wear, compare a slightly firmer option without assuming the firmest cup will be best.'
        ],
        ['Soft cup', 'Opening technique', 'Possible firmness change'],
        link('Use the opening guide', paths.opening),
        link('Compare soft and firm cups', paths.firmness),
        '',
        false,
        'Try this first'
      ),

      open_position: result(
        'Change where and how you release the fold',
        'An average or firm cup that remains dented may be opening against the cervix, pubic bone or a tense area of the pelvic floor.',
        'The rim needs enough space to expand. Higher is not automatically better.',
        [
          'Insert towards your tailbone rather than straight upwards.',
          'Release the fold slightly lower or higher than usual.',
          'Run a finger around the body and press the vaginal wall away from any dent.',
          'If the open cup feels crowded or painful, check its length and diameter instead of moving to a firmer model.'
        ],
        ['Release position', 'Insertion angle', 'Length and diameter'],
        link('Use the opening guide', paths.opening),
        link('Review cup folds', paths.folds),
        '',
        false,
        'Try this first'
      ),

      open_collapses: result(
        'The cup may be too soft or unstable for this pressure pattern',
        'A cup that opens but later becomes dented may change shape during movement or when pelvic-floor and abdominal pressure change.',
        'Firmness is one factor, but shape and diameter also affect stability.',
        [
          'Confirm the cup was fully open and correctly positioned at the start.',
          'Notice whether collapse happens during exercise, bowel movements or particular positions.',
          'Compare a somewhat firmer cup with similar comfortable dimensions.',
          'Do not increase firmness if your current cup already causes bladder pressure or pain.'
        ],
        ['Firmness', 'Stability', 'Movement'],
        link('Compare cup firmness', paths.firmness),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      opens_early: result(
        'Keep control of the fold for a little longer',
        'The cup is probably releasing before the widest part passes the vaginal opening.',
        'Some folds and firmer cups spring open earlier than others.',
        [
          'Hold the fold closer to the rim during insertion.',
          'Try a punch-down or another narrow fold with a controlled release.',
          'Angle the cup towards your tailbone and release only after the rim is fully inside.',
          'Use a small amount of compatible water-based lubricant if the manufacturer permits it.'
        ],
        ['Fold control', 'Narrow insertion point', 'Angle'],
        link('Compare cup folds', paths.folds),
        link('Read the insertion guide', paths.howTo),
        '',
        false,
        'Technique adjustment'
      ),

      opening_basics: result(
        'Check the cup body rather than waiting for a “pop”',
        'Some cups open quietly. Check whether the rim and body feel rounded without a persistent fold or deep dent.',
        'Sound and rotation are not reliable opening tests for every cup or body.',
        [
          'With clean hands, trace around the cup body after insertion.',
          'If you feel a dent, adjust the height, press beside it or gently wiggle the base.',
          'Check that your cervix is not sitting beside the rim.',
          'Use backup protection while learning and change one part of your technique at a time.'
        ],
        ['Beginner check', 'No pop required', 'Cervix position'],
        link('Use the opening guide', paths.opening),
        link('Read the beginner guide', paths.beginner),
        '',
        false,
        'Start here'
      ),

      overflow_slip: result(
        'The weight of a full cup may be contributing to movement',
        'If the cup descends only when full, emptying sooner may solve the problem without changing size or firmness.',
        'A cervix sitting inside the cup can reduce usable capacity and make it heavy sooner than expected.',
        [
          'Empty the cup before it usually starts moving down.',
          'Note the time and amount on heavier days.',
          'If frequent emptying is impractical, compare higher usable capacity without choosing a cup too long for your cervix.',
          'If it also slips while empty, restart and select that option.'
        ],
        ['Capacity', 'Empty sooner', 'Cervix space'],
        link('Read the slipping guide', paths.slipping),
        link('Compare cup capacity', paths.comparison),
        '',
        false,
        'Most likely'
      ),

      observe_slip: result(
        'Check fullness and cervix height before changing cups',
        'Slipping may relate to fullness, length, diameter, shape, firmness or downward pressure.',
        'A low-feeling stem needs a different solution from a cup body that repeatedly descends.',
        [
          'Check how full the cup is when it moves down.',
          'Notice whether only the stem or the whole cup feels low.',
          'Measure your cervix during your period.',
          'Restart this tool with those details.'
        ],
        ['Observe first', 'Fullness', 'Cervix height'],
        link('Read the slipping guide', paths.slipping),
        link('Measure your cervix', paths.cervix),
        '',
        false,
        'Best next step'
      ),

      cup_too_long: result(
        'The cup may be too long for your cervix position',
        'If the cup body feels crowded or sits at the vaginal opening when the cervix is low, trimming the stem alone may not solve it.',
        'Cup body length, not just total length including the stem, determines how much internal space is needed.',
        [
          'Measure your cervix on more than one day of your period.',
          'Compare the body length of your current cup, excluding the stem where appropriate.',
          'If the body is too long, consider a shorter-bodied cup or another product type.',
          'Only trim a stem when the manufacturer allows it and the cup body itself is comfortable.'
        ],
        ['Low cervix', 'Shorter body', 'Check stem instructions'],
        link('Measure your cervix', paths.cervix),
        link('Compare cup length', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      slip_fit: result(
        'Diameter, shape or firmness may not provide stable support',
        'A cup that repeatedly descends while not full may not be stable for your anatomy, pelvic-floor interaction or activity.',
        'Choosing “large” by age or birth history alone does not show which dimension needs to change.',
        [
          'Confirm the cup is fully open and not being pushed down by fullness.',
          'Notice whether it is squashed, folded, rotated or simply moving lower.',
          'Compare diameter, body shape and firmness with your current cup.',
          'If you have prolapse symptoms, pelvic pressure, urinary symptoms or persistent difficulty keeping internal products in place, seek individual professional advice.'
        ],
        ['Diameter', 'Shape', 'Firmness', 'Pelvic-floor factors'],
        link('Read the slipping guide', paths.slipping),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      check_cervix: result(
        'Measure your cervix during your period',
        'Cervix height helps determine whether the cup feels low because it is too long or is moving down for another reason.',
        'Cervical position may change across your period, so one check outside it can be misleading.',
        [
          'With clean hands, measure during your period when comfortable doing so.',
          'Repeat on another day if cup fit changes across the cycle.',
          'Compare the result with cup body length, not only the labelled size.',
          'Return to the slipping pathway once you know whether your cervix is low, average or high.'
        ],
        ['Cervix height', 'Cup body length'],
        link('How to measure your cervix', paths.cervix),
        link('Compare cup length', paths.comparison),
        '',
        false,
        'Best next step'
      ),

      slip_toilet: result(
        'Bearing down may be moving the cup lower',
        'Pelvic-floor and abdominal pressure used during a bowel movement can move a cup towards the vaginal opening.',
        'Occasional movement on the toilet does not automatically mean the cup is the wrong size.',
        [
          'Prevent the cup from falling into the toilet. Removing it beforehand may feel more secure.',
          'Afterwards, wash your hands and check that the cup is open and correctly positioned.',
          'If it stays low, slips at other times or causes pressure, review cervix height, diameter, shape and firmness.',
          'Avoid straining where possible and seek health advice for ongoing constipation or pelvic-floor symptoms.'
        ],
        ['Bearing down', 'Recheck position', 'Not automatically poor fit'],
        link('Read the slipping guide', paths.slipping),
        null,
        '',
        false,
        'Likely explanation'
      ),

      narrow_fold: result(
        'Try a fold with a narrower insertion point',
        'The labelled cup size does not show how wide it becomes when folded.',
        'Punch-down, seven-fold and triangle-style folds may create a narrower entry point than a C-fold, depending on the cup.',
        [
          'Practise two or three folds with clean hands before insertion.',
          'Choose the narrowest fold that you can still hold securely.',
          'Insert towards your tailbone and release only after the rim is inside.',
          'Stop if you encounter pain or strong resistance.'
        ],
        ['Narrow fold', 'Controlled release', 'Do not force'],
        link('Compare menstrual cup folds', paths.folds),
        link('Read the insertion steps', paths.howTo),
        '',
        false,
        'Technique adjustment'
      ),

      insert_angle: result(
        'Aim towards your tailbone, not straight upwards',
        'The vaginal canal generally angles back towards the tailbone. Pushing vertically may meet resistance or position the cup away from the cervix.',
        'Body position can also change the angle and how easily the pelvic floor relaxes.',
        [
          'Try sitting on the toilet, squatting or standing with one foot raised.',
          'Relax your jaw, abdomen and pelvic floor, then guide the folded cup towards your tailbone.',
          'Pause rather than pushing harder if you meet resistance.',
          'Once inserted, check that the cup is open and the cervix is not beside the rim.'
        ],
        ['Insertion angle', 'Body position', 'Pelvic-floor relaxation'],
        link('Follow the insertion guide', paths.howTo),
        link('Try a dry run', paths.dryRun),
        '',
        false,
        'Technique adjustment'
      ),

      persistent_insertion_pain: result(
        'The difficulty may not be specific to the cup',
        'When tampons, fingers, penetrative sex, examinations or other insertion are also painful or impossible, repeatedly trying smaller or softer cups may not address the cause.',
        'Pelvic-floor overactivity, vaginismus, irritation, infection and other conditions can contribute. A professional can help assess what is happening.',
        [
          'Stop the attempt if it is painful.',
          'Use an external period product that feels comfortable for now.',
          'Consider speaking with a GP, pelvic-health physiotherapist or another appropriately qualified professional.',
          'Return to internal products only at a pace that feels safe and appropriate.'
        ],
        ['Stop if painful', 'Pelvic-health support', 'No forced insertion'],
        link('Read about cup pain', paths.hurting),
        link('Find a pelvic-health physiotherapist', paths.physio),
        'Seek prompt medical advice for significant pain, unexplained bleeding, unusual discharge, swelling, fever or urinary symptoms.',
        true,
        'Do not push through this'
      ),

      cup_insertion: result(
        'Reduce friction and change the fold or angle',
        'If discomfort is specific to this cup, folded width, firmness, surface friction or angle may be contributing.',
        'A cup can be comfortable during wear but awkward to insert, so assess insertion separately from fit once open.',
        [
          'Wet the cup or use a small amount of compatible water-based lubricant if the manufacturer permits it.',
          'Try a fold with a narrower insertion point.',
          'Insert slowly towards your tailbone while relaxing your jaw, abdomen and pelvic floor.',
          'If the same cup repeatedly hurts despite gentle technique, compare folded width, diameter and firmness.'
        ],
        ['Friction', 'Fold', 'Angle', 'Firmness'],
        link('Compare cup folds', paths.folds),
        link('Read about cup pain', paths.hurting),
        '',
        false,
        'Try this first'
      ),

      gentle_trial: result(
        'Use one gentle, low-pressure practice session',
        'A dry run can help separate unfamiliar technique from pain or involuntary muscle tightening.',
        'The aim is observation, not forcing successful insertion.',
        [
          'Choose a private time when you are not rushed.',
          'Read the insertion and removal steps before starting.',
          'Use a narrow fold and compatible water-based lubricant if permitted.',
          'Stop if your muscles strongly tighten, insertion is painful or you feel distressed.'
        ],
        ['Dry run', 'Gentle practice', 'Stop with pain'],
        link('How to do a dry run', paths.dryRun),
        link('Read about cup pain', paths.hurting),
        'If insertion of other objects is also painful or impossible, seek professional support rather than repeating painful attempts.',
        true,
        'Best next step'
      ),

      urgent_help: result(
        'Do not continue trying to remove it by force',
        'Severe pain, inability to urinate or symptoms such as sudden fever, vomiting, diarrhoea, dizziness, confusion, muscle aches or a widespread red rash need medical attention.',
        'A retained cup can be removed by a healthcare professional. Toxic shock syndrome is rare but serious and can develop quickly.',
        [
          'Seek urgent medical care. In Australia, call 000 for an emergency.',
          'Tell the healthcare professional that a menstrual cup is in place and when it was inserted.',
          'Do not use tools or ask an untrained person to forcefully remove it.',
          'If you can remove it easily and safely, do so, but do not delay care to keep attempting removal.'
        ],
        ['Urgent care', 'Do not force', 'No tools'],
        link('Healthdirect: toxic shock syndrome', 'https://www.healthdirect.gov.au/toxic-shock-syndrome'),
        null,
        'Your immediate wellbeing comes first. This pathway intentionally does not recommend another product.',
        true,
        'Seek medical help now'
      ),

      stuck_calm: result(
        'Release the seal before bringing the cup down',
        'A menstrual cup cannot travel beyond the vagina, but tension and a high cervix can make it difficult to reach.',
        'Pulling the stem without releasing the seal may cause pain and make the pelvic floor tighten further.',
        [
          'Stop pulling and take a break if you are becoming tense. Wash your hands before trying again.',
          'Squat or sit on the toilet, relax your jaw and abdomen, then bear down gently as if having a bowel movement.',
          'Use the stem only to locate or guide the cup. Pinch the base to release the seal.',
          'If you cannot reach the base, slide one clean finger beside the cup and press the rim inward, then wiggle it down gradually.',
          'Do not use tweezers, tongs or other tools. Seek medical help if you still cannot remove it or removal becomes painful.'
        ],
        ['Release seal', 'Bear down gently', 'No tools'],
        link('Follow the stuck-cup guide', paths.stuck),
        null,
        '',
        false,
        'Stay calm'
      ),

      high_removal: result(
        'The cup may be too short for your cervix height or reach',
        'A cup can move higher as the cervix rises, particularly overnight. The stem may locate it but should not be used for forceful removal.',
        'Body length and removal features may matter more than the manufacturer’s small or large label.',
        [
          'Squat or sit, relax and bear down gently to bring the cup within reach.',
          'Pinch the base or press the rim inward to release the seal before removing it.',
          'Measure your cervix during your period and compare body and total length.',
          'If this happens repeatedly, consider a longer cup or a removal feature suited to your dexterity and reach.'
        ],
        ['High cervix', 'Longer body', 'Removal feature'],
        link('Read the stuck-cup guide', paths.stuck),
        link('Compare cup length', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      release_seal: result(
        'Break the seal before pulling the cup down',
        'Pain or strong resistance during removal often happens while the rim is still in full contact with the vaginal walls.',
        'The stem helps locate or guide most cups; it is not designed to carry the full pulling force.',
        [
          'Bring the cup lower by bearing down gently rather than pulling hard on the stem.',
          'Pinch the base until you feel the seal release.',
          'If pinching is not enough, slide one finger beside the cup and press the rim inward.',
          'Keep it upright and wiggle gently from side to side during removal.'
        ],
        ['Release seal', 'Pinch base', 'Do not pull stem'],
        link('Follow the removal guide', paths.howTo),
        link('Read the stuck-cup guide', paths.stuck),
        '',
        false,
        'Technique adjustment'
      ),

      refold_removal: result(
        'Partly refold the rim as it comes out',
        'An open rim may feel too wide at the vaginal opening even when the cup was comfortable during wear.',
        'Reducing rim width during the final part of removal can make the exit gentler.',
        [
          'Release the seal and bring the cup down while keeping it upright.',
          'Pinch the base and fold one side of the rim inward into a loose C shape.',
          'Remove one side of the rim at a time rather than pulling it straight out fully open.',
          'Slow down or stop if removal causes sharp pain.'
        ],
        ['Refold rim', 'Slow removal', 'Keep upright'],
        link('Follow the removal guide', paths.howTo),
        link('Read about cup pain', paths.hurting),
        '',
        false,
        'Technique adjustment'
      ),

      removal_basics: result(
        'Use position, relaxation and seal release together',
        'Removal is easier when the cup is within reach, the pelvic floor is relaxed and the seal is released first.',
        'Rushing and pulling on the stem may increase tension and discomfort.',
        [
          'Wash your hands and choose a comfortable squat or seated position.',
          'Bear down gently until you can reach the base.',
          'Pinch the base or press the rim inward to release the seal.',
          'Wiggle the cup down and partly refold the rim as it exits.'
        ],
        ['Relax', 'Bear down', 'Release seal'],
        link('Follow the removal guide', paths.howTo),
        link('Try a dry run', paths.dryRun),
        '',
        false,
        'Start here'
      ),

      bladder_bowel: result(
        'The cup may be pressing on a sensitive area',
        'Difficulty urinating, bladder pressure or discomfort with bowel movements may indicate that firmness, diameter, shape or position is not comfortable.',
        'A cup should not make normal urination difficult.',
        [
          'Remove the cup and check whether the pressure settles.',
          'Reinsert once in a slightly different position only if comfortable doing so.',
          'If the problem returns, compare a softer cup, narrower diameter or different shape.',
          'Seek advice if urinary or bowel symptoms persist after removal, are significant or occur without the cup.'
        ],
        ['Firmness', 'Diameter', 'Position'],
        link('Read about cup pain', paths.hurting),
        link('Compare cup firmness', paths.firmness),
        'Seek prompt medical help if you cannot urinate.',
        true,
        'Remove and reassess'
      ),

      iud_concern: result(
        'New pain or changed IUD strings needs individual advice',
        'Do not assume new pain is simply a cup-fit problem if you use an IUD or think its position may have changed.',
        'Research about menstrual cup use and IUD expulsion is still developing, and advice may depend on the IUD and your circumstances.',
        [
          'Stop using the cup until you have appropriate advice.',
          'Do not pull on the IUD strings or repeatedly check them if doing so causes pain.',
          'Contact the healthcare professional or service responsible for your IUD care.',
          'Seek urgent care for severe pain, very heavy bleeding, fainting or feeling seriously unwell.'
        ],
        ['IUD', 'Stop cup use', 'Professional advice'],
        link('Read the cup and IUD guide', paths.iud),
        null,
        'This result does not attempt to determine whether the IUD has moved.',
        true,
        'Stop using the cup for now'
      ),

      bladder_pressure: result(
        'The cup may be too firm, wide or prominent in the wrong area',
        'Bladder awareness, urgency or a slower urine stream that resolves after removal may be related to cup pressure.',
        'Firmness, diameter, rim design and shape all influence where pressure is felt.',
        [
          'Remove the cup and make sure urination returns to normal.',
          'Try one comfortable repositioning rather than forcing the cup higher.',
          'If symptoms return, compare a softer cup, narrower diameter or different shape.',
          'Seek healthcare advice if symptoms persist after removal or occur without the cup.'
        ],
        ['Softer', 'Narrower', 'Different shape'],
        link('Compare soft and firm cups', paths.firmness),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      deep_pain: result(
        'Deep cramping or aching should not be pushed through',
        'A cup that is too long, firm, wide or positioned against the cervix may contribute, but pelvic pain can have other causes.',
        'Whether pain settles after removal is useful information, but it does not diagnose the cause.',
        [
          'Remove the cup and note whether the pain settles.',
          'If it does, review length, diameter, firmness and cervix position before trying again.',
          'If pain returns with the cup, stop using it rather than repeatedly testing through pain.',
          'Seek healthcare advice if pain is significant, persists after removal, keeps returning or occurs with other symptoms.'
        ],
        ['Remove', 'Length', 'Firmness', 'Cervix position'],
        link('Read about cup pain', paths.hurting),
        link('Measure your cervix', paths.cervix),
        'Seek prompt advice for pelvic pain with fever, unusual discharge, unexplained bleeding, urinary symptoms or pregnancy concerns.',
        true,
        'Remove the cup'
      ),

      wear_pressure: result(
        'Review length, diameter, shape and firmness separately',
        'General pressure during wear means the cup is noticeable in a way that is not comfortable for you.',
        '“Smaller” is not one measurement. A shorter cup can still be wide or firm, while a softer cup can still be too long.',
        [
          'Remove the cup and confirm that discomfort settles.',
          'Identify whether pressure feels low, deep, towards the bladder or generally around the cup.',
          'Compare the relevant measurement or feature rather than changing every characteristic.',
          'Stop using the cup and seek advice if pain is persistent or significant.'
        ],
        ['Length', 'Diameter', 'Shape', 'Firmness'],
        link('Read about cup pain', paths.hurting),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'Possible fit issue'
      ),

      stem_trim: result(
        'The stem may be too long for your anatomy',
        'If the cup body feels comfortable and only the stem rubs or pokes, the stem may need adjustment or a different design.',
        'Trimming helps only when the cup body itself sits comfortably inside.',
        [
          'Remove and clean the cup before making any adjustment.',
          'Check the manufacturer’s instructions because not every stem should be altered.',
          'If trimming is allowed, remove only a small amount at a time and leave a smooth edge.',
          'If the cup body also feels low, compare a shorter-bodied cup instead of continuing to trim.'
        ],
        ['Stem length', 'Check instructions', 'Trim gradually'],
        link('Read about cup pain', paths.hurting),
        link('Compare stems and length', paths.comparison),
        '',
        false,
        'Likely explanation'
      ),

      stains: result(
        'Staining does not automatically mean the cup is unsafe',
        'Cup materials may discolour over time even when cleaned regularly.',
        'Condition matters more than colour alone. Inspect for odour, tackiness, cracks, tears or surface deterioration.',
        [
          'Clean the cup according to the manufacturer’s instructions.',
          'Use only a stain-removal method compatible with that material and brand.',
          'Rinse thoroughly and allow it to dry completely before breathable storage.',
          'Replace it if discolouration occurs with material damage or persistent odour.'
        ],
        ['Cosmetic staining', 'Material-specific care', 'Inspect condition'],
        link('How to remove cup stains', paths.stains),
        link('Check cup lifespan', paths.lifespan),
        '',
        false,
        'Usually cosmetic'
      ),

      odour: result(
        'Clean and inspect the cup',
        'Odour may be influenced by wear time, cleaning, incomplete drying or material condition.',
        'Strong or unusual vaginal odour or discharge is different from an odour limited to the cup.',
        [
          'Clean and sanitise the cup exactly as its manufacturer directs.',
          'Allow it to dry completely and store it in a breathable container.',
          'Inspect it for tackiness, cracks, tears or other deterioration.',
          'Stop using it if odour persists after correct care or the material appears damaged.'
        ],
        ['Cleaning', 'Complete drying', 'Inspect material'],
        link('Check cup lifespan', paths.lifespan),
        link('Read the cup safety guide', paths.safety),
        'Seek healthcare advice for unusual vaginal discharge, a new unpleasant vaginal smell, irritation, fever or pelvic pain.',
        true,
        'Clean and inspect'
      ),

      wear_cleaning: result(
        'Wear time and cleaning guidance may vary by product',
        'Use the instructions supplied with your specific cup and empty it sooner when your flow requires it.',
        'Australian menstrual cup information must limit stated wear duration to no more than 12 hours, but a manufacturer may specify a shorter time.',
        [
          'Wash your hands before insertion and removal.',
          'Empty, rinse and clean the cup as directed by its manufacturer.',
          'Do not exceed the manufacturer’s maximum wear time or 12 hours, whichever is shorter.',
          'Sanitise between cycles and store dry in a breathable pouch or container as directed.'
        ],
        ['Manufacturer instructions', 'Maximum 12 hours', 'Clean hands'],
        link('Read about wear time', paths.wear),
        link('Read the cup safety guide', paths.safety),
        'Remove the cup and seek urgent medical care if you develop symptoms that could indicate toxic shock syndrome.',
        true,
        'Follow your cup instructions'
      ),

      beginner: result(
        'Learn insertion, opening and removal as separate skills',
        'A new cup often involves a learning curve. You do not need to perfect every step in one attempt or keep trying when sore or frustrated.',
        'Working on one stage at a time makes it easier to understand what needs adjusting.',
        [
          'Read the complete insertion and removal guide before your first wear.',
          'Practise two folds and choose one you can hold securely.',
          'Use backup protection and check the cup after a shorter first wear.',
          'Try a calm dry run if helpful, but stop if insertion is painful.'
        ],
        ['Beginner', 'One skill at a time', 'Backup protection'],
        link('Read the beginner guide', paths.beginner),
        link('Try a dry run', paths.dryRun),
        '',
        false,
        'A good place to begin'
      ),

      contact: result(
        'Tell Period Shop what is happening',
        'Some problems need more context than a decision tree can collect.',
        'Useful details include cup brand and size, cervix height, flow, when the problem occurs, fullness and what you have already tried.',
        [
          'Note the cup brand, model and size.',
          'Describe when the problem starts and what you find on removal.',
          'Include any comfort, bladder, removal or cervix-height information that seems relevant.',
          'Do not send intimate photographs. Written details are enough to begin.'
        ],
        ['Individual guidance', 'Product and fit details'],
        link('Contact Period Shop', paths.contact),
        link('Compare cup specifications', paths.comparison),
        '',
        false,
        'We can help'
      )
    };

    const element = (tag, className = '', text = '') => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;

      root.dataset.initialised = 'true';

      const screen = root.querySelector('[data-tool-screen]');
      const back = root.querySelector('[data-back]');
      const restart = root.querySelector('[data-restart]');
      const progress = root.querySelector('.psct-progress');
      const progressBar = root.querySelector('[data-progress-bar]');
      const history = [];

      const setProgress = (value) => {
        progress.setAttribute('aria-valuenow', String(value));
        progressBar.style.width = `${value}%`;
      };

      const renderQuestion = (key) => {
        const item = questions[key];
        screen.replaceChildren();

        const wrapper = element('div', 'psct-question');
        wrapper.append(element('p', 'psct-result-kicker', history.length ? `Question ${history.length + 1}` : 'Start here'));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psct-question-copy', item.copy));

        const options = element('div', 'psct-options');

        item.choices.forEach((answer) => {
          const button = element('button', 'psct-option');
          button.type = 'button';
          button.append(element('strong', '', answer.label));

          if (answer.detail) {
            button.append(element('span', '', answer.detail));
          }

          button.addEventListener('click', () => {
            history.push(key);

            if (answer.next.startsWith('r:')) {
              renderResult(answer.next.slice(2));
            } else {
              renderQuestion(answer.next);
            }
          });

          options.append(button);
        });

        wrapper.append(options);
        screen.append(wrapper);
        back.hidden = history.length === 0;
        restart.hidden = history.length === 0;
        setProgress(Math.min(86, 20 + history.length * 18));
      };

      const renderResult = (key) => {
        const item = results[key];
        screen.replaceChildren();

        const wrapper = element('article', 'psct-result');
        wrapper.append(element('p', 'psct-result-kicker', item.kicker));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psct-result-summary', item.summary));
        wrapper.append(element('h3', '', 'Why this may be happening'));
        wrapper.append(element('p', 'psct-result-why', item.why));
        wrapper.append(element('h3', '', 'What to try next'));

        const steps = element('ol', 'psct-steps');
        item.steps.forEach((step) => steps.append(element('li', '', step)));
        wrapper.append(steps);

        if (item.note) {
          const note = element('p', 'psct-result-note', item.note);
          note.dataset.medical = item.medical ? 'true' : 'false';
          wrapper.append(note);
        }

        if (item.tags.length) {
          wrapper.append(element('h3', '', 'Factors to keep in mind'));

          const tags = element('div', 'psct-tags');
          item.tags.forEach((tag) => tags.append(element('span', 'psct-tag', tag)));
          wrapper.append(tags);
        }

        const actions = element('div', 'psct-actions');

        if (item.primary) {
          const primary = element('a', 'psct-cta psct-cta-primary', item.primary.label);
          primary.href = item.primary.url;
          actions.append(primary);
        }

        if (item.secondary) {
          const secondary = element('a', 'psct-cta psct-cta-secondary', item.secondary.label);
          secondary.href = item.secondary.url;
          actions.append(secondary);
        }

        wrapper.append(actions);
        screen.append(wrapper);
        back.hidden = false;
        restart.hidden = false;
        setProgress(100);
      };

      back.addEventListener('click', () => {
        const previous = history.pop();

        if (previous) {
          renderQuestion(previous);
        }
      });

      restart.addEventListener('click', () => {
        history.length = 0;
        renderQuestion('issue');
      });

      renderQuestion('issue');
    };

    document.querySelectorAll('[data-ps-cup-tool]').forEach(initialise);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ps-cup-tool]').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["period-shop-menstrual-disc-troubleshooter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const paths = {
      howTo: '/blogs/all/how-to-use-a-menstrual-disc',
      untucked: '/blogs/all/why-does-my-menstrual-disc-keep-coming-untucked',
      autoDump: '/blogs/all/menstrual-disc-auto-dumping',
      comparison: '/blogs/all/menstrual-disc-comparison-chart',
      iud: '/blogs/all/using-menstrual-cups-or-discs-with-iuds',
      dryRun: '/blogs/all/how-to-do-a-dry-run-with-a-menstrual-cup-or-disc',
      lifespan: '/blogs/all/what-is-the-lifespan-of-a-menstrual-cup-or-disc',
      quiz: '/pages/quiz',
      discs: '/collections/menstrual-discs',
      physio: '/pages/find-a-pelvic-health-physiotherapist',
      contact: '/pages/contact-us'
    };

    const choice = (label, next, detail = '') => ({ label, next, detail });
    const question = (title, copy, choices) => ({ title, copy, choices });
    const link = (label, url) => ({ label, url });
    const result = (title, summary, why, steps, tags, primary, secondary = null, note = '', medical = false, kicker = 'Your result') => ({
      title, summary, why, steps, tags, primary, secondary, note, medical, kicker
    });

    const questions = {
      issue: question('What are you having trouble with?', 'Choose the problem that best matches what is happening now.', [
        choice('My disc is leaking', 'leak_when', 'Spotting, ongoing leaks or overflow'),
        choice('My disc keeps coming untucked', 'untuck_when', 'The front rim slips from behind the pubic bone'),
        choice('I am having trouble inserting or positioning it', 'insert_problem', 'Friction, angle, depth or tucking'),
        choice('I am having trouble removing it', 'remove_problem', 'It feels high, stuck, painful or messy'),
        choice('It causes pain or pressure', 'pain_when', 'Pelvic, bladder, rectal or pubic-bone pressure'),
        choice('It releases fluid when I use the toilet', 'dump_pattern', 'Possible auto-dumping or toilet-related leaking'),
        choice('I am having a problem during penetrative sex', 'sex_problem', 'Movement, leaking, discomfort or uncertainty'),
        choice('I have a cleaning or disc-care question', 'care_problem', 'Odour, stains, damage, wear time or reuse'),
        choice('I use an IUD and something feels different', 'r:iud_concern'),
        choice('I am new and not sure what is wrong', 'r:beginner'),
        choice('My problem is not listed', 'r:contact')
      ]),
      leak_when: question('When does the leaking happen?', 'Timing helps separate residual blood, capacity, placement, auto-dumping and fit.', [
        choice('Only a few spots soon after insertion', 'r:residual'),
        choice('Almost immediately or within an hour', 'leak_early'),
        choice('After several hours', 'leak_fullness'),
        choice('Mostly while walking, coughing or exercising', 'r:movement_leak'),
        choice('Only when I use the toilet', 'dump_pattern'),
        choice('I am not sure', 'r:observe_leak')
      ]),
      leak_early: question('Have you checked whether your cervix is inside the disc bowl?', 'A disc can feel fully inserted while the rim has passed in front of the cervix.', [
        choice('No or I cannot tell', 'r:cervix_outside'),
        choice('Yes, my cervix is inside the bowl', 'leak_tuck'),
        choice('I cannot reach or locate my cervix', 'r:placement_basics')
      ]),
      leak_fullness: question('How full is the disc when you remove it?', 'Capacity is useful only after checking actual fullness and position.', [
        choice('Full or nearly full', 'r:overflow'),
        choice('Partly full', 'leak_tuck'),
        choice('Mostly empty', 'leak_early'),
        choice('I have not checked', 'r:observe_leak')
      ]),
      leak_tuck: question('Does the front rim stay tucked above your pubic bone?', 'Check after insertion and again when the leaking starts.', [
        choice('No, it slips down', 'untuck_when'),
        choice('Yes, it stays tucked', 'r:leak_fit'),
        choice('I am not sure', 'r:placement_basics')
      ]),
      untuck_when: question('When does the front rim come untucked?', 'The situation in which it moves is an important clue.', [
        choice('Immediately after insertion', 'untuck_immediate'),
        choice('After several hours or when it is full', 'r:untuck_full'),
        choice('Only while I am on the toilet', 'dump_pattern'),
        choice('During walking, coughing, exercise or sleep', 'untuck_pressure'),
        choice('I am not sure', 'r:observe_untuck')
      ]),
      untuck_immediate: question('Is the back of the disc positioned behind your cervix?', 'Inserting upwards rather than back towards the tailbone can leave the disc in front of the cervix.', [
        choice('No or I am not sure', 'r:not_far_back'),
        choice('Yes, the cervix is inside the bowl', 'untuck_pressure'),
        choice('I cannot tuck the front rim at all', 'r:tuck_fit')
      ]),
      untuck_pressure: question('Does the disc also cause pressure or feel as though it is springing out?', 'Comfort and the direction of movement can help narrow down the fit issue.', [
        choice('Yes, it feels tight, firm or pressurised', 'r:large_or_firm'),
        choice('No pressure; it feels loose or slides down', 'r:small_or_soft'),
        choice('It is comfortable but still moves', 'r:disc_fit'),
        choice('I cannot tell', 'r:disc_fit')
      ]),
      insert_problem: question('What makes insertion or positioning difficult?', 'Do not force the disc through pain or strong resistance.', [
        choice('The pinched rim feels too wide', 'r:narrow_insert'),
        choice('There is friction, dryness, burning or stinging', 'insert_other'),
        choice('I cannot find the correct angle or depth', 'r:not_far_back'),
        choice('I cannot tuck the front rim behind my pubic bone', 'r:tuck_fit'),
        choice('My muscles tighten or insertion is painful', 'insert_other')
      ]),
      insert_other: question('Is other vaginal insertion also painful or difficult?', 'Think about tampons, a clean finger, penetrative sex or a pelvic examination.', [
        choice('Yes, other insertion is also painful or difficult', 'r:persistent_insertion_pain'),
        choice('No, it seems specific to this disc', 'r:disc_insertion'),
        choice('I am not sure', 'r:gentle_trial')
      ]),
      remove_problem: question('Which removal problem best matches?', 'Do not use tools or keep pulling forcefully.', [
        choice('The disc is stuck right now', 'remove_safety'),
        choice('I cannot reach or hook the front rim', 'r:high_removal'),
        choice('The removal tab, loop or tail is difficult to use', 'r:removal_feature'),
        choice('Removal hurts', 'r:removal_pain'),
        choice('Removal is very messy', 'r:messy_removal')
      ]),
      remove_safety: question('Are you in severe pain or feeling unwell?', 'This determines whether self-help steps are appropriate.', [
        choice('Yes, or I have fever, vomiting, dizziness, rash or cannot urinate', 'r:urgent_help'),
        choice('No, I feel well but cannot remove it', 'r:stuck_calm')
      ]),
      pain_when: question('When do you feel the pain or pressure?', 'Remove the disc if discomfort is significant, worsening or does not settle after repositioning.', [
        choice('During insertion', 'insert_other'),
        choice('While the disc is in place', 'pain_type'),
        choice('During removal', 'r:removal_pain'),
        choice('During penetrative sex', 'r:sex_pain'),
        choice('New pain with an IUD or my strings feel different', 'r:iud_concern')
      ]),
      pain_type: question('Where do you notice it most?', 'The location and type of discomfort can point to different fit factors.', [
        choice('Bladder pressure, urgency or a slower urine stream', 'r:bladder_pressure'),
        choice('Pressure at the front or behind the pubic bone', 'r:front_pressure'),
        choice('Deep cramps, aching or pressure near the cervix', 'r:deep_pain'),
        choice('Rectal pressure or discomfort with bowel movements', 'r:bowel_pressure'),
        choice('General internal pressure or fullness', 'r:wear_pressure')
      ]),
      dump_pattern: question('What happens after fluid is released on the toilet?', 'Auto-dumping is fit-dependent and is not essential for a disc to work.', [
        choice('It retucks itself and stays secure afterwards', 'r:auto_dump_normal'),
        choice('I retuck it easily and it stays secure afterwards', 'r:auto_dump_retuck'),
        choice('It stays untucked or leaks afterwards', 'r:toilet_untuck'),
        choice('It also leaks during everyday movement', 'r:movement_leak'),
        choice('I am trying to make it auto-dump', 'r:auto_dump_optional')
      ]),
      sex_problem: question('What is happening during penetrative sex?', 'Use a disc during sex only if its manufacturer says it is designed for this purpose.', [
        choice('I am not sure whether this disc can be worn during sex', 'r:sex_instructions'),
        choice('The disc moves or leaks', 'r:sex_movement'),
        choice('It causes pain or significant pressure', 'r:sex_pain'),
        choice('My partner can feel it', 'r:partner_feels')
      ]),
      care_problem: question('What would you like help with?', 'First check whether your disc is reusable or single-use and follow its supplied instructions.', [
        choice('Staining or discolouration', 'r:stains'),
        choice('An odour that remains after cleaning', 'r:odour'),
        choice('Cracks, tears, stickiness or other damage', 'r:replace_disc'),
        choice('Wear time or routine cleaning', 'r:wear_cleaning'),
        choice('Whether a disposable disc can be reused', 'r:single_use')
      ])
    };

    const results = {
      residual: result('This may be residual blood rather than an ongoing leak', 'A small amount of blood can remain below the disc after insertion and appear as a few spots even when the disc is collecting normally.', 'If the spotting stops and the disc contains fluid when removed, the disc may be working correctly.', [
        'After positioning the disc, wipe away any blood below it with clean toilet paper or a damp cloth.',
        'Use backup protection while testing if that helps you feel more confident.',
        'If the spotting becomes an ongoing flow, restart this tool and choose the timing that best matches.'
      ], ['Technique check', 'No new disc yet'], link('Read the disc guide', paths.howTo), null, '', false, 'Most likely'),
      observe_leak: result('Check timing, placement and fullness before changing anything', 'The most useful clues are when leaking begins, whether your cervix is inside the bowl, whether the rim stays tucked and how full the disc is.', 'Changing several things at once makes it harder to identify residual blood, placement, capacity or fit.', [
        'Use backup protection for one wear test.',
        'Note when you inserted the disc and when leaking begins.',
        'Check that your cervix is inside the bowl and the front rim is above the pubic bone.',
        'On removal, check how full the disc actually is.'
      ], ['Observe first', 'Placement', 'Fullness'], link('Follow the disc guide', paths.howTo), null, '', false, 'Best next step'),
      cervix_outside: result('Your cervix may be sitting outside the disc bowl', 'A disc can feel inserted but leak immediately if the rim passes in front of the cervix.', 'The disc needs to sit under and around the cervix so menstrual flow enters the bowl.', [
        'With clean hands, locate your cervix if you can do so comfortably.',
        'Pinch the disc and guide it back towards your tailbone rather than straight upwards.',
        'Push the back rim as far back as is comfortable, then tuck the front rim above the pubic bone.',
        'After insertion, check that you cannot feel the cervix outside or below the bowl.'
      ], ['Cervix position', 'Insertion angle', 'Placement'], link('See the insertion steps', paths.howTo), link('Try a dry run', paths.dryRun), '', false, 'Possible cause'),
      placement_basics: result('Recheck the full placement sequence', 'A disc must move behind the cervix before the front rim is tucked above the pubic bone.', 'Feeling only the front rim does not confirm that the back of the disc is in the correct position.', [
        'Pinch the disc narrowly and insert it towards your tailbone.',
        'Push it back as far as is comfortably possible.',
        'Use a clean finger to lift the front rim above the pubic bone.',
        'Use backup protection while learning and reassess if leaking continues.'
      ], ['Back first', 'Then tuck', 'Use backup'], link('Follow the disc guide', paths.howTo), link('Try a dry run', paths.dryRun), '', false, 'Start here'),
      overflow: result('The disc is probably reaching its usable capacity', 'A disc that begins leaking when full or nearly full is more likely overflowing than fitting incorrectly.', 'Advertised capacity does not always equal usable capacity in your body because the bowl may compress during wear.', [
        'Empty the disc sooner and note how long it takes to fill on heavier days.',
        'Check that it is positioned around the cervix rather than partly folded in front of it.',
        'Do not rely on auto-dumping as your only overflow plan.',
        'If frequent emptying is impractical, compare usable capacity alongside diameter, firmness and comfort.'
      ], ['Capacity', 'Empty sooner', 'Compressed bowl'], link('Compare menstrual discs', paths.comparison), link('Read about auto-dumping', paths.autoDump), 'If you repeatedly fill a disc very quickly, bleed through protection or feel dizzy, breathless or unusually fatigued, speak with a healthcare professional about the bleeding.', true, 'Most likely'),
      leak_fit: result('The disc may not be maintaining a reliable fit', 'If the cervix is inside the bowl, the rim stays tucked, the disc is not full and it still leaks, its diameter, shape or firmness may not suit your anatomy.', 'Disc fit is not determined by age or a single measurement, and the largest capacity is not automatically the best fit.', [
        'Repeat one careful wear test to confirm placement and fullness.',
        'Notice whether the rim shifts, the bowl stays compressed or leaking happens with particular movement.',
        'Compare your current disc with alternatives by diameter, shape, rim firmness and removal design.',
        'Change one characteristic at a time when possible.'
      ], ['Diameter', 'Shape', 'Rim firmness'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible fit issue'),
      movement_leak: result('Movement may be shifting the disc or untucking the rim', 'Fluid released while walking, coughing, sneezing, exercising or sleeping is leaking rather than normal toilet-only auto-dumping.', 'Placement, fullness, diameter, shape and rim firmness can all influence stability.', [
        'Check that the back rim is behind your cervix and the front rim is securely above the pubic bone.',
        'Make sure the disc is not already close to full before activity.',
        'Notice whether it feels tight and springs out or feels loose and slides down.',
        'Compare another diameter, shape or rim firmness if correct placement does not solve it.'
      ], ['Everyday leaking', 'Placement', 'Fit'], link('Troubleshoot untucking', paths.untucked), link('Compare menstrual discs', paths.comparison), '', false, 'Not typical auto-dumping'),
      untuck_full: result('Fullness may be contributing to untucking', 'A full or compressed bowl can place more pressure on the rim and make the front easier to dislodge.', 'This is more likely a capacity issue if the disc remains secure earlier in the wear period.', [
        'Empty the disc before it usually becomes untucked.',
        'Retuck the front rim with a clean finger after using the toilet.',
        'Track the reliable wear interval on heavier days.',
        'If it also untucks when nearly empty, reassess placement and fit.'
      ], ['Capacity', 'Empty sooner', 'Retuck'], link('Troubleshoot untucking', paths.untucked), link('Read about auto-dumping', paths.autoDump), '', false, 'Likely explanation'),
      observe_untuck: result('Note when and how the rim moves', 'Untucking only on the toilet suggests a different pathway from a disc that moves during ordinary activity.', 'Fullness, placement and the direction of pressure provide useful clues before changing discs.', [
        'Check the rim immediately after insertion and again when you notice leaking.',
        'Note whether it happens on the toilet, during activity or only when the disc is full.',
        'Check whether the cervix is inside the bowl.',
        'Restart this tool with those details.'
      ], ['Observe first', 'Timing', 'Placement'], link('Troubleshoot untucking', paths.untucked), null, '', false, 'Best next step'),
      not_far_back: result('Guide the back rim towards your tailbone first', 'A common placement problem is directing a disc upwards like a tampon instead of sliding it back into the vaginal fornix behind the cervix.', 'If it stops in front of the cervix, the bowl may not collect flow and the front rim may be difficult to tuck.', [
        'Try sitting, squatting or standing with one foot raised.',
        'Pinch the rim and angle the disc back towards your tailbone.',
        'Push the rear rim as far back as is comfortably possible before lifting the front rim.',
        'Do not force it if you meet pain or strong resistance.'
      ], ['Insertion angle', 'Back rim', 'Cervix placement'], link('See the insertion steps', paths.howTo), link('Try a dry run', paths.dryRun), '', false, 'Technique adjustment'),
      tuck_fit: result('Check depth first, then consider diameter or shape', 'If the rear rim is not far enough back, there may not be enough room to lift the front rim above the pubic bone. If placement is correct, fit may be the issue.', 'A disc that is too large or too springy may push itself out, while a smaller or differently shaped disc may sit more securely.', [
        'Reinsert towards the tailbone and push the rear rim fully back before tucking the front.',
        'Use one clean finger to lift the front rim rather than pushing the whole disc upwards.',
        'If it still cannot remain tucked, compare diameter, shape and rim firmness.',
        'Stop if the disc causes significant pressure or makes urination difficult.'
      ], ['Depth first', 'Diameter', 'Shape and firmness'], link('Troubleshoot untucking', paths.untucked), link('Compare menstrual discs', paths.comparison), '', false, 'Placement or fit'),
      large_or_firm: result('The disc may be too large, firm or springy for this position', 'A disc that feels tight, causes pressure or repeatedly springs out from behind the pubic bone may be exerting more force than is comfortable.', 'Diameter, shape and rim firmness work together, so “smaller” is not the only possible change.', [
        'Confirm that the back rim is fully behind the cervix before assessing fit.',
        'Remove the disc and check whether pressure settles.',
        'Compare a smaller diameter, softer rim or different shape.',
        'Seek advice if pressure, numbness, pain or urinary difficulty persists after removal.'
      ], ['Diameter', 'Softer rim', 'Different shape'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible fit issue'),
      small_or_soft: result('The disc may not be stable enough for your anatomy', 'A disc that feels loose, descends or untucks without pressure may be too small, too soft or the wrong shape for stable support.', 'A larger or firmer disc is not automatically better, so retain any features that already feel comfortable.', [
        'Confirm that the back rim is behind the cervix and the disc is not full.',
        'Notice whether the rim folds, the bowl rotates or the whole disc moves down.',
        'Compare a slightly larger diameter, more structured rim or different shape.',
        'Stop if a firmer alternative creates bladder pressure or pain.'
      ], ['Diameter', 'Rim structure', 'Shape'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible fit issue'),
      disc_fit: result('Diameter, shape or rim firmness may need adjusting', 'A correctly positioned disc that repeatedly untucks during ordinary wear may not be stable for your anatomy and activity.', 'There is no universally correct disc diameter or firmness.', [
        'Confirm placement and rule out fullness with one controlled wear test.',
        'Note whether the disc springs out, slides down or folds.',
        'Compare that pattern with alternatives by diameter, shape and rim firmness.',
        'Choose comfort and stability together rather than focusing only on capacity.'
      ], ['Diameter', 'Shape', 'Firmness'], link('Compare menstrual discs', paths.comparison), link('Browse menstrual discs', paths.discs), '', false, 'Possible fit issue'),
      narrow_insert: result('Compress the rim evenly and keep the leading end narrow', 'Some disc rims are wide or structured and can feel bulky if the two sides are not held closely together.', 'Grip and insertion angle can change the folded width without changing discs.', [
        'Pinch the rim firmly into a narrow figure-eight shape.',
        'Hold close to the leading end so it does not open during insertion.',
        'Use a small amount of compatible water-based lubricant if the manufacturer permits it.',
        'If folded width remains uncomfortable, compare a narrower, softer or differently shaped disc.'
      ], ['Narrow pinch', 'Controlled insertion', 'Rim design'], link('See the insertion steps', paths.howTo), link('Compare menstrual discs', paths.comparison), '', false, 'Technique adjustment'),
      persistent_insertion_pain: result('The difficulty may not be specific to the disc', 'When tampons, fingers, penetrative sex, examinations or other insertion are also painful or impossible, repeatedly trying different discs may not address the cause.', 'Pelvic-floor overactivity, vaginismus, irritation, infection and other conditions can contribute. A professional can help assess what is happening.', [
        'Stop the attempt if it is painful.',
        'Use an external period product that feels comfortable for now.',
        'Consider speaking with a GP, pelvic-health physiotherapist or another appropriately qualified professional.',
        'Return to internal products only at a pace that feels safe and appropriate.'
      ], ['Stop if painful', 'Pelvic-health support', 'No forced insertion'], link('Find a pelvic-health physiotherapist', paths.physio), null, 'Seek prompt medical advice for significant pain, unexplained bleeding, unusual discharge, swelling, fever or urinary symptoms.', true, 'Do not push through this'),
      disc_insertion: result('Reduce friction and adjust the grip or angle', 'If discomfort is specific to this disc, folded width, rim firmness, surface friction or insertion angle may be contributing.', 'Insertion comfort and stability during wear are separate parts of fit.', [
        'Wet the disc or use a small amount of compatible water-based lubricant if the manufacturer permits it.',
        'Pinch the rim evenly and hold it close to the leading edge.',
        'Insert slowly towards your tailbone while relaxing your jaw, abdomen and pelvic floor.',
        'If the same disc repeatedly hurts, compare rim width, firmness, shape and removal features.'
      ], ['Friction', 'Grip', 'Angle', 'Rim firmness'], link('See the insertion steps', paths.howTo), link('Compare menstrual discs', paths.comparison), '', false, 'Try this first'),
      gentle_trial: result('Use one gentle, low-pressure practice session', 'A dry run can help separate unfamiliar technique from pain or involuntary muscle tightening.', 'The aim is observation, not forcing successful insertion.', [
        'Choose a private time when you are not rushed.',
        'Read the insertion and removal steps before starting.',
        'Use compatible water-based lubricant if the manufacturer permits it.',
        'Stop if your muscles strongly tighten, insertion is painful or you feel distressed.'
      ], ['Dry run', 'Gentle practice', 'Stop with pain'], link('How to do a dry run', paths.dryRun), link('Read the disc guide', paths.howTo), 'If insertion of other objects is also painful or impossible, seek professional support rather than repeating painful attempts.', true, 'Best next step'),
      urgent_help: result('Do not continue trying to remove it by force', 'Severe pain, inability to urinate or symptoms such as sudden fever, vomiting, diarrhoea, dizziness, confusion, muscle aches or a widespread red rash need medical attention.', 'A retained disc can be removed by a healthcare professional. Toxic shock syndrome is rare but serious and can develop quickly.', [
        'Seek urgent medical care. In Australia, call 000 for an emergency.',
        'Tell the healthcare professional that a menstrual disc is in place and when it was inserted.',
        'Do not use tweezers, tongs or other tools.',
        'If you can remove it easily and safely, do so, but do not delay care to keep attempting removal.'
      ], ['Urgent care', 'Do not force', 'No tools'], link('Healthdirect: toxic shock syndrome', 'https://www.healthdirect.gov.au/toxic-shock-syndrome'), null, 'Your immediate wellbeing comes first. This pathway intentionally does not recommend another product.', true, 'Seek medical help now'),
      stuck_calm: result('Relax, bear down gently and hook the front rim', 'A disc cannot travel beyond the vagina, but it can move high enough to be difficult to reach.', 'Tension can make the pelvic floor tighten and make removal harder.', [
        'Stop and take a break if you are becoming tense. Wash your hands before trying again.',
        'Sit on the toilet or squat, relax your jaw and abdomen, then bear down gently as if having a bowel movement.',
        'Hook a clean finger under the front rim or use the disc’s removal feature as instructed.',
        'Bring the rim forwards and down slowly. Do not use tools.',
        'Seek medical help if you still cannot remove it or removal becomes painful.'
      ], ['Relax', 'Bear down gently', 'No tools'], link('Follow the removal guide', paths.howTo), null, '', false, 'Stay calm'),
      high_removal: result('Bring the disc within reach before hooking the rim', 'A disc sits high in the vaginal fornix, and the front rim may be harder to reach when the pelvic floor is tense.', 'Bearing down gently can move the rim towards the vaginal opening.', [
        'Sit on the toilet or squat and allow your jaw, abdomen and pelvic floor to relax.',
        'Bear down gently rather than reaching and pulling harder.',
        'Hook the front rim with one clean finger or use the designated removal feature.',
        'If this repeatedly exceeds your reach, compare removal tabs, loops, notches or stems.'
      ], ['Position', 'Bear down', 'Removal feature'], link('Follow the removal guide', paths.howTo), link('Compare removal designs', paths.comparison), '', false, 'Technique or design issue'),
      removal_feature: result('Use the removal feature exactly as the manufacturer directs', 'Tabs, loops, notches and tails are designed differently. Some guide the rim within reach while others are intended to pull the disc down.', 'Pulling in the wrong direction or using too much force may fold the disc, cause spills or damage the feature.', [
        'Check the instructions for your exact disc model.',
        'Bear down gently to bring the disc closer before using the feature.',
        'Move slowly and keep fingernails away from thin silicone.',
        'If the feature remains unsuitable for your dexterity or reach, compare another removal design.'
      ], ['Product instructions', 'Removal design', 'Dexterity'], link('Compare removal designs', paths.comparison), link('Follow the disc guide', paths.howTo), '', false, 'Design-specific technique'),
      removal_pain: result('Painful removal should not be forced', 'The rim may be pressing against a sensitive area, the disc may be angled awkwardly or the pelvic floor may tighten during removal.', 'A disc does not need a cup-style suction release, but slow positioning still matters.', [
        'Pause, relax and bear down gently until the front rim is easier to reach.',
        'Hook the rim and bring one side down first rather than pulling the full width straight out.',
        'Keep fingernails away from the vaginal wall and disc material.',
        'Stop using the disc and seek advice if removal repeatedly causes significant pain.'
      ], ['Slow removal', 'One side first', 'Stop with pain'], link('Follow the removal guide', paths.howTo), link('Compare menstrual discs', paths.comparison), 'Seek prompt advice if pain persists after removal or occurs with fever, unusual discharge, unexplained bleeding or urinary symptoms.', true, 'Slow down and reassess'),
      messy_removal: result('Keep the disc level and lower one edge at the end', 'Disc removal can be messier than cup removal, particularly while learning or when the bowl is full.', 'Body position, fullness and how soon the disc tilts all affect spills.', [
        'Practise over the toilet or in the shower until the movement feels familiar.',
        'Bear down gently, hook the front rim and slide the disc forwards while keeping it level.',
        'Once it is near the opening, pinch or lower one edge and tip the contents into the toilet.',
        'Empty it sooner if an overfull bowl is difficult to keep level.'
      ], ['Keep level', 'Remove over toilet', 'Empty sooner'], link('Follow the removal guide', paths.howTo), null, '', false, 'Technique adjustment'),
      bladder_pressure: result('The disc may be pressing towards the bladder or urethra', 'Urgency, bladder awareness or a slower urine stream that resolves after removal may relate to diameter, rim firmness, shape or position.', 'A disc should not make normal urination difficult.', [
        'Remove the disc and confirm that urination returns to normal.',
        'Try one comfortable repositioning only if symptoms fully settle.',
        'If pressure returns, compare a smaller diameter, softer rim or different shape.',
        'Seek healthcare advice if urinary symptoms persist after removal or occur without the disc.'
      ], ['Smaller diameter', 'Softer rim', 'Position'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), 'Seek prompt medical help if you cannot urinate.', true, 'Remove and reassess'),
      front_pressure: result('The front rim may be too prominent behind the pubic bone', 'A rim that feels firm, pinching or constantly noticeable at the front may be too large, too structured or not tucked in a comfortable position.', 'The pubic bone should support the disc without significant discomfort.', [
        'Remove the disc and check whether the pressure settles.',
        'On one gentle retry, make sure the back rim is fully positioned before tucking the front.',
        'If discomfort returns, compare a softer rim, smaller diameter or different shape.',
        'Do not persist through numbness, pain or urinary difficulty.'
      ], ['Front rim', 'Diameter', 'Firmness'], link('Compare menstrual discs', paths.comparison), link('Troubleshoot untucking', paths.untucked), '', false, 'Possible fit issue'),
      deep_pain: result('Deep cramping or aching should not be pushed through', 'A disc positioned against the cervix or a disc that is too large, firm or prominent may contribute, but pelvic pain can have other causes.', 'Whether pain settles after removal is useful information, but it does not diagnose the cause.', [
        'Remove the disc and note whether the pain settles.',
        'If it does, review placement, diameter, shape and rim firmness before trying again.',
        'If pain returns with the disc, stop using it rather than repeatedly testing through pain.',
        'Seek healthcare advice if pain is significant, persists after removal, keeps returning or occurs with other symptoms.'
      ], ['Remove', 'Placement', 'Diameter', 'Firmness'], link('Compare menstrual discs', paths.comparison), null, 'Seek prompt advice for pelvic pain with fever, unusual discharge, unexplained bleeding, urinary symptoms or pregnancy concerns.', true, 'Remove the disc'),
      bowel_pressure: result('The disc may be pressing towards the rectum', 'Rectal pressure or discomfort with bowel movements may relate to disc diameter, rim firmness, shape or how the back rim is positioned.', 'Bearing down can also shift the disc temporarily.', [
        'Remove the disc and check whether the pressure settles.',
        'Avoid straining and consider removing the disc before a bowel movement if that feels more comfortable.',
        'If symptoms return, compare a smaller, softer or differently shaped disc.',
        'Seek healthcare advice if symptoms persist after removal or occur without the disc.'
      ], ['Diameter', 'Softer rim', 'Back position'], link('Compare menstrual discs', paths.comparison), null, '', false, 'Possible fit issue'),
      wear_pressure: result('Review diameter, shape and rim firmness separately', 'General pressure during wear means the disc is noticeable in a way that is not comfortable for you.', 'A smaller disc can still have a firm rim, while a softer disc may still have a shape that does not suit your anatomy.', [
        'Remove the disc and confirm that discomfort settles.',
        'Identify whether pressure feels at the front, deep, towards the bladder or towards the rectum.',
        'Compare the relevant feature rather than changing every characteristic.',
        'Stop using the disc and seek advice if pain is persistent or significant.'
      ], ['Diameter', 'Shape', 'Rim firmness'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible fit issue'),
      auto_dump_normal: result('This sounds like normal toilet-only auto-dumping', 'Some discs temporarily release fluid when pelvic pressure changes on the toilet, then retuck by themselves.', 'If the disc is comfortable, secure and leak-free during ordinary activity, auto-dumping alone does not mean the fit is wrong.', [
        'Check that the front rim is back above the pubic bone before leaving the bathroom.',
        'Wipe away residual blood around the vaginal opening.',
        'Continue to remove, empty and clean the disc at the interval in its instructions.',
        'Reassess if it begins leaking or untucking away from the toilet.'
      ], ['Auto-dumping', 'Toilet only', 'Check the tuck'], link('Read about auto-dumping', paths.autoDump), null, 'Auto-dumping does not reset wear time or replace scheduled removal and cleaning.', false, 'Likely explanation'),
      auto_dump_retuck: result('This is likely auto-dumping, but remember to retuck', 'Some discs release fluid on the toilet and need a clean finger to return the front rim above the pubic bone.', 'If retucking is easy and the disc stays secure during ordinary activity, it may still be a suitable fit.', [
        'Wash your hands before checking the disc.',
        'Push the front rim back above the pubic bone after the toilet visit.',
        'Wipe away any residual blood before dressing.',
        'Continue scheduled removal and cleaning as directed.'
      ], ['Auto-dumping', 'Retuck', 'Wear time unchanged'], link('Read about auto-dumping', paths.autoDump), link('Troubleshoot untucking', paths.untucked), 'If the rim will not stay retucked or leaks during everyday movement, treat it as a placement or fit issue.', false, 'Likely explanation'),
      toilet_untuck: result('The disc may need retucking, earlier emptying or a fit review', 'A disc that stays untucked after using the toilet is more likely to leak afterwards.', 'Fullness, placement, diameter, shape and rim firmness can influence whether it returns to position.', [
        'Use a clean finger to push the front rim back above the pubic bone.',
        'Empty the disc sooner on heavier days.',
        'Check that the back rim is behind the cervix rather than in front of it.',
        'If it repeatedly will not retuck, compare another diameter, shape or firmness.'
      ], ['Retuck', 'Empty sooner', 'Placement and fit'], link('Troubleshoot untucking', paths.untucked), link('Compare menstrual discs', paths.comparison), '', false, 'Needs attention'),
      auto_dump_optional: result('A disc does not need to auto-dump to fit well', 'Auto-dumping is a fit-dependent user experience, not a required feature or a reliable measure of correct sizing.', 'Trying to force it by straining may be uncomfortable and is unnecessary.', [
        'Do not strain or repeatedly bear down to make the disc release fluid.',
        'Empty the disc normally at the interval required by your flow and product instructions.',
        'Judge fit by comfort, secure placement and reliable leak protection.',
        'If capacity is the concern, compare capacity together with diameter and comfort.'
      ], ['Optional behaviour', 'Do not strain', 'Normal removal'], link('Read about auto-dumping', paths.autoDump), link('Compare menstrual discs', paths.comparison), '', false, 'Good to know'),
      sex_instructions: result('Check whether your exact disc is designed for penetrative sex', 'Some menstrual discs are designed to be worn during penetrative vaginal sex and others are not.', 'Product-specific instructions take priority because rim designs, removal features and materials differ.', [
        'Check the packaging or manufacturer instructions for your disc model.',
        'Do not use it during sex unless the instructions allow this use.',
        'Remember that a menstrual disc is not contraception and does not protect against sexually transmitted infections.',
        'Stop if either person experiences pain or significant discomfort.'
      ], ['Check instructions', 'Not contraception', 'No STI protection'], link('Read the disc guide', paths.howTo), null, '', false, 'Check first'),
      sex_movement: result('Placement, fullness or fit may be changing during sex', 'Penetration can shift a disc, compress the bowl or dislodge the front rim in some bodies and positions.', 'A disc designed for sex can still be the wrong size, shape or firmness for an individual body.', [
        'Confirm that your disc is approved by its manufacturer for use during penetrative sex.',
        'Insert it before sex and check that the back rim surrounds the cervix and the front is securely tucked.',
        'Empty it first if it is already partly full.',
        'If it repeatedly shifts, compare diameter, shape, firmness and removal-feature position.'
      ], ['Placement', 'Empty first', 'Fit'], link('Compare menstrual discs', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), 'A menstrual disc is not contraception and does not protect against sexually transmitted infections.', false, 'Possible placement or fit issue'),
      sex_pain: result('Stop if the disc causes pain during sex', 'Pain may relate to disc position, diameter, rim firmness, removal features or another pelvic-health factor.', 'Neither person should need to push through pain to keep using the disc.', [
        'Stop penetration and remove the disc gently if comfortable doing so.',
        'Check whether the disc is designed for use during penetrative sex.',
        'Do not retry until pain has settled.',
        'If pain recurs, consider another design or seek professional advice, especially if sex is painful without the disc too.'
      ], ['Stop with pain', 'Check instructions', 'Pelvic-health support'], link('Find a pelvic-health physiotherapist', paths.physio), link('Compare menstrual discs', paths.comparison), 'Seek medical advice for significant or persistent pain, unexplained bleeding or other concerning symptoms.', true, 'Stop and reassess'),
      partner_feels: result('A partner may notice the rim or a removal feature', 'Whether a disc can be felt depends on anatomy, position, disc shape and the design of tabs, loops or tails.', 'Being able to feel it is not automatically harmful, but sharpness, pain or significant discomfort means you should stop.', [
        'Confirm that the disc is designed for use during penetrative sex.',
        'Check that it is fully inserted and securely tucked behind the pubic bone.',
        'Try a comfortable position that places less contact on the rim or removal feature.',
        'Compare a different shape, rim firmness or less prominent removal design if needed.'
      ], ['Position', 'Removal feature', 'Comfort'], link('Compare menstrual discs', paths.comparison), null, 'A menstrual disc is not contraception and does not protect against sexually transmitted infections.', false, 'Often design-dependent'),
      iud_concern: result('New pain or changed IUD strings needs individual advice', 'Do not assume new pain or changed strings are simply a disc-fit problem.', 'Disc-specific research on IUD expulsion is limited. Discs do not rely on suction, but that does not establish zero risk.', [
        'Stop using the disc until you have appropriate advice.',
        'Do not pull on the IUD strings or repeatedly check them if doing so causes pain.',
        'Contact the healthcare professional or service responsible for your IUD care.',
        'Seek urgent care for severe pain, very heavy bleeding, fainting or feeling seriously unwell.'
      ], ['IUD', 'Stop disc use', 'Professional advice'], link('Read the disc and IUD guide', paths.iud), null, 'This result does not attempt to determine whether the IUD has moved.', true, 'Stop using the disc for now'),
      stains: result('Staining does not automatically mean the disc is unsafe', 'Reusable disc materials may discolour over time even when cleaned regularly.', 'Condition matters more than colour alone. Inspect for odour, tackiness, cracks, tears or surface deterioration.', [
        'Clean the disc according to the manufacturer’s instructions.',
        'Use only a stain-removal method compatible with that material and brand.',
        'Rinse thoroughly and allow it to dry completely before breathable storage.',
        'Replace it if discolouration occurs with material damage or persistent odour.'
      ], ['Cosmetic staining', 'Material-specific care', 'Inspect condition'], link('Check cup and disc lifespan', paths.lifespan), null, '', false, 'Usually cosmetic'),
      odour: result('Clean and inspect the disc', 'Odour may be influenced by wear time, cleaning, incomplete drying or material condition.', 'Strong or unusual vaginal odour or discharge is different from an odour limited to the disc.', [
        'Clean and sanitise the reusable disc exactly as its manufacturer directs.',
        'Allow it to dry completely and store it as instructed.',
        'Inspect it for tackiness, cracks, tears or other deterioration.',
        'Stop using it if odour persists after correct care or the material appears damaged.'
      ], ['Cleaning', 'Complete drying', 'Inspect material'], link('Check cup and disc lifespan', paths.lifespan), null, 'Seek healthcare advice for unusual vaginal discharge, a new unpleasant vaginal smell, irritation, fever or pelvic pain.', true, 'Clean and inspect'),
      replace_disc: result('Stop using a damaged reusable disc', 'Cracks, tears, stickiness, permanent deformation or damage to a removal feature are reasons to stop using it.', 'Damage can make a reusable disc harder to clean and may affect performance or comfort.', [
        'Stop using the disc and check the manufacturer’s replacement guidance.',
        'Do not glue, cut or attempt to repair the material or removal feature.',
        'Review whether cleaning, storage or age may have contributed.',
        'If it otherwise fitted well, compare replacements with similar dimensions and features.'
      ], ['Replace', 'Material condition', 'Do not repair'], link('Check cup and disc lifespan', paths.lifespan), link('Compare replacement discs', paths.comparison), '', false, 'Stop using this disc'),
      wear_cleaning: result('Follow the instructions for your exact disc', 'Wear time and cleaning vary between products, particularly between reusable and disposable discs.', 'Auto-dumping does not reset wear time or replace removal and cleaning.', [
        'Wash your hands before insertion and removal.',
        'Follow the maximum wear time supplied with your disc and empty it sooner when your flow requires it.',
        'Period Shop’s general guidance is to remove and clean a reusable disc at least every 12 hours, or sooner.',
        'Sanitise and store reusable discs as directed; discard single-use discs after use.'
      ], ['Manufacturer instructions', 'Maximum wear time', 'Reusable or single-use'], link('Read the disc guide', paths.howTo), link('Read about auto-dumping', paths.autoDump), 'Remove the disc and seek urgent medical care if you develop symptoms that could indicate toxic shock syndrome.', true, 'Follow your disc instructions'),
      single_use: result('Do not reuse a disc labelled single-use', 'Disposable menstrual discs are designed for one use unless the manufacturer explicitly states otherwise.', 'Washing a single-use product does not convert it into a reusable disc and may damage material not designed for repeated wear.', [
        'Check the packaging to confirm whether the disc is reusable or single-use.',
        'Discard a single-use disc after removal according to its instructions.',
        'Do not flush it down the toilet.',
        'Choose a purpose-designed reusable disc if you want a washable option.'
      ], ['Single-use', 'Do not wash and reuse', 'Do not flush'], link('Browse reusable discs', paths.discs), link('Compare menstrual discs', paths.comparison), '', false, 'Product type matters'),
      beginner: result('Learn insertion, positioning and removal as separate skills', 'A new disc often involves a learning curve. You do not need to perfect every step in one attempt or keep trying when sore or frustrated.', 'Working on one stage at a time makes it easier to identify the adjustment you need.', [
        'Read the complete insertion and removal guide before your first full wear.',
        'Practise pinching the rim and guiding it towards your tailbone.',
        'Check that the back sits around the cervix before tucking the front above the pubic bone.',
        'Use backup protection and try a shorter first wear while learning.'
      ], ['Beginner', 'One skill at a time', 'Use backup'], link('Read the disc guide', paths.howTo), link('Try a dry run', paths.dryRun), '', false, 'A good place to begin'),
      contact: result('Tell Period Shop what is happening', 'Some problems need more context than a decision tree can collect.', 'Useful details include disc brand and size, when the problem occurs, fullness, placement, comfort and what you have already tried.', [
        'Note the disc brand, model and size or diameter.',
        'Describe when the problem starts and what you find on removal.',
        'Include whether it stays tucked, whether your cervix is inside the bowl and whether it causes pressure.',
        'Do not send intimate photographs. Written details are enough to begin.'
      ], ['Individual guidance', 'Product and fit details'], link('Contact Period Shop', paths.contact), link('Compare menstrual discs', paths.comparison), '', false, 'We can help')
    };

    const element = (tag, className = '', text = '') => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';
      const screen = root.querySelector('[data-tool-screen]');
      const back = root.querySelector('[data-back]');
      const restart = root.querySelector('[data-restart]');
      const progress = root.querySelector('.psdt-progress');
      const progressBar = root.querySelector('[data-progress-bar]');
      const history = [];

      const setProgress = (value) => {
        progress.setAttribute('aria-valuenow', String(value));
        progressBar.style.width = `${value}%`;
      };

      const renderQuestion = (key) => {
        const item = questions[key];
        screen.replaceChildren();
        const wrapper = element('div', 'psdt-question');
        wrapper.append(element('p', 'psdt-result-kicker', history.length ? `Question ${history.length + 1}` : 'Start here'));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psdt-question-copy', item.copy));
        const options = element('div', 'psdt-options');

        item.choices.forEach((answer) => {
          const button = element('button', 'psdt-option');
          button.type = 'button';
          button.append(element('strong', '', answer.label));
          if (answer.detail) button.append(element('span', '', answer.detail));
          button.addEventListener('click', () => {
            history.push(key);
            if (answer.next.startsWith('r:')) renderResult(answer.next.slice(2));
            else renderQuestion(answer.next);
          });
          options.append(button);
        });

        wrapper.append(options);
        screen.append(wrapper);
        back.hidden = history.length === 0;
        restart.hidden = history.length === 0;
        setProgress(Math.min(86, 20 + history.length * 18));
      };

      const renderResult = (key) => {
        const item = results[key];
        screen.replaceChildren();
        const wrapper = element('article', 'psdt-result');
        wrapper.append(element('p', 'psdt-result-kicker', item.kicker));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psdt-result-summary', item.summary));
        wrapper.append(element('h3', '', 'Why this may be happening'));
        wrapper.append(element('p', 'psdt-result-why', item.why));
        wrapper.append(element('h3', '', 'What to try next'));
        const steps = element('ol', 'psdt-steps');
        item.steps.forEach((step) => steps.append(element('li', '', step)));
        wrapper.append(steps);

        if (item.note) {
          const note = element('p', 'psdt-result-note', item.note);
          note.dataset.medical = item.medical ? 'true' : 'false';
          wrapper.append(note);
        }

        if (item.tags.length) {
          wrapper.append(element('h3', '', 'Factors to keep in mind'));
          const tags = element('div', 'psdt-tags');
          item.tags.forEach((tag) => tags.append(element('span', 'psdt-tag', tag)));
          wrapper.append(tags);
        }

        const actions = element('div', 'psdt-actions');
        if (item.primary) {
          const primary = element('a', 'psdt-cta psdt-cta-primary', item.primary.label);
          primary.href = item.primary.url;
          actions.append(primary);
        }
        if (item.secondary) {
          const secondary = element('a', 'psdt-cta psdt-cta-secondary', item.secondary.label);
          secondary.href = item.secondary.url;
          actions.append(secondary);
        }
        wrapper.append(actions);
        screen.append(wrapper);
        back.hidden = false;
        restart.hidden = false;
        setProgress(100);
      };

      back.addEventListener('click', () => {
        const previous = history.pop();
        if (previous) renderQuestion(previous);
      });
      restart.addEventListener('click', () => {
        history.length = 0;
        renderQuestion('issue');
      });
      renderQuestion('issue');
    };

    document.querySelectorAll('[data-ps-disc-tool]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ps-disc-tool]').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["period-shop-menstrual-sponge-troubleshooter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const paths = {
      howToSea: '/blogs/all/how-to-use-a-menstrual-sea-sponge',
      overview: '/blogs/all/everything-you-need-to-know-about-period-sponges',
      comparison: '/blogs/all/menstrual-sponges-comparison-chart',
      periodSex: '/blogs/all/period-sex-tips-how-to-have-mess-free-sex-during-your-period',
      products: '/collections/sponge-tampons',
      reusable: '/collections/reusable-period-sponges',
      disposable: '/collections/single-use-period-sponges',
      quiz: '/pages/quiz',
      physio: '/pages/find-a-pelvic-health-physiotherapist',
      contact: '/pages/contact-us',
      tss: 'https://www.healthdirect.gov.au/toxic-shock-syndrome',
      retained: 'https://www.healthdirect.gov.au/retained-object-or-tampon'
    };

    const choice = (label, next, detail = '') => ({ label, next, detail });
    const question = (title, copy, choices) => ({ title, copy, choices });
    const link = (label, url) => ({ label, url });
    const result = (title, summary, why, steps, tags, primary, secondary = null, note = '', medical = false, kicker = 'Your result') => ({
      title, summary, why, steps, tags, primary, secondary, note, medical, kicker
    });

    const questions = {
      issue: question('What are you having trouble with?', 'Choose the problem that best matches what is happening now.', [
        choice('My sponge is leaking', 'leak_when', 'Spotting, ongoing leaks or saturation'),
        choice('Insertion is difficult', 'insert_type', 'Dryness, size, angle or muscle tension'),
        choice('It slips, moves or feels too low', 'move_pattern', 'During wear, activity or when saturated'),
        choice('Removal is difficult', 'remove_problem', 'It feels high, stuck, painful or messy'),
        choice('It causes pain, pressure or irritation', 'pain_when', 'During insertion, wear, removal or sex'),
        choice('I have a cleaning or care question', 'care_type', 'Cleaning, drying, odour, wear time or reuse'),
        choice('I am having a problem during penetrative sex', 'sex_type', 'Suitability, leaking, movement or removal'),
        choice('I am worried the sponge is damaged', 'damage_type', 'Tears, loose pieces, odour or packaging damage'),
        choice('My flow seems too heavy for it', 'r:heavy_bleeding'),
        choice('I want to understand sponge safety', 'r:safety_overview'),
        choice('I am new and not sure what is wrong', 'r:beginner'),
        choice('My problem is not listed', 'r:contact')
      ]),
      leak_when: question('When does the leaking happen?', 'Timing helps separate residual blood, saturation, placement and fit.', [
        choice('Only a few spots soon after insertion', 'r:residual'),
        choice('Almost immediately or within an hour', 'leak_position'),
        choice('After some time or on a heavier-flow day', 'r:saturated'),
        choice('When I cough, exercise or move around', 'move_pattern'),
        choice('During or after penetrative sex', 'sex_type'),
        choice('I am not sure', 'r:observe_leak')
      ]),
      leak_position: question('How does the sponge feel when the leaking starts?', 'A sponge needs to sit fully inside the vaginal canal and have enough absorbency for the flow.', [
        choice('I can feel it near the vaginal opening', 'r:not_high_enough'),
        choice('It feels secure but is saturated on removal', 'r:saturated'),
        choice('It feels secure and is not saturated', 'leak_type'),
        choice('I cannot tell', 'r:observe_leak')
      ]),
      leak_type: question('Which type of sponge are you using?', 'Reusable sea sponges and single-use synthetic sponges have different sizing and care options.', [
        choice('A reusable natural sea sponge', 'r:sea_fit_capacity'),
        choice('A single-use synthetic sponge', 'r:single_fit_capacity'),
        choice('I am not sure', 'r:type_check')
      ]),
      insert_type: question('Which type of sponge are you trying to insert?', 'Use only the preparation method supplied for that exact product.', [
        choice('A reusable natural sea sponge', 'sea_insert'),
        choice('A pre-moistened single-use sponge', 'single_insert'),
        choice('A dry single-use sponge', 'single_insert'),
        choice('I am not sure', 'r:type_check')
      ]),
      sea_insert: question('What makes sea-sponge insertion difficult?', 'Do not force the sponge through pain or strong resistance.', [
        choice('It feels firm, dry or difficult to compress', 'r:damp_prepare'),
        choice('It feels too large or bulky', 'r:trim_or_size'),
        choice('I cannot find the right angle or depth', 'r:placement_basics'),
        choice('There is burning, stinging or irritation', 'r:irritation'),
        choice('My muscles tighten or other insertion is also painful', 'r:persistent_insertion_pain')
      ]),
      single_insert: question('What makes single-use sponge insertion difficult?', 'Wet and dry versions can have different instructions, so check the packet before adding water or lubricant.', [
        choice('There is friction or it feels too dry', 'r:single_instructions'),
        choice('It feels too large or bulky', 'r:single_size'),
        choice('I cannot find the right angle or depth', 'r:placement_basics'),
        choice('The sponge or gel causes burning or stinging', 'r:irritation'),
        choice('My muscles tighten or other insertion is also painful', 'r:persistent_insertion_pain')
      ]),
      move_pattern: question('When does the sponge move or sit too low?', 'The timing helps distinguish placement, saturation and product fit.', [
        choice('Straight after insertion', 'r:not_high_enough'),
        choice('Only after it becomes saturated', 'r:saturated'),
        choice('During walking, coughing, swimming or exercise', 'r:fit_stability'),
        choice('During or after penetrative sex', 'sex_type'),
        choice('It is always noticeable or causes pressure', 'r:pressure')
      ]),
      remove_problem: question('Which removal problem best matches?', 'Do not use tweezers, scissors or another tool inside the vagina.', [
        choice('The sponge is stuck right now', 'remove_safety'),
        choice('I cannot find or grip the finger slit', 'r:removal_feature'),
        choice('There is no string, slit or removal aid', 'r:removal_feature'),
        choice('The sponge tore or a piece may be missing', 'r:retained_piece'),
        choice('Removal hurts', 'r:removal_pain'),
        choice('Removal is very messy', 'r:messy_removal')
      ]),
      remove_safety: question('Are you in severe pain or feeling unwell?', 'This determines whether gentle self-help steps are appropriate.', [
        choice('Yes, or I have fever, vomiting, dizziness, rash or cannot urinate', 'r:urgent_help'),
        choice('No, I feel well but cannot remove it', 'r:stuck_calm'),
        choice('I think part of the sponge is still inside', 'r:retained_piece')
      ]),
      pain_when: question('When do you feel pain, pressure or irritation?', 'Remove the sponge if discomfort is significant, worsening or does not settle.', [
        choice('During insertion', 'pain_pattern'),
        choice('While it is in place', 'pain_wear'),
        choice('During removal', 'r:removal_pain'),
        choice('During penetrative sex', 'r:sex_pain'),
        choice('I have itching, unusual discharge or an unpleasant vaginal smell', 'r:irritation_signs'),
        choice('I feel suddenly or seriously unwell', 'r:urgent_help')
      ]),
      pain_pattern: question('Is other vaginal insertion also painful or difficult?', 'Think about a tampon, clean finger, penetrative sex or pelvic examination.', [
        choice('Yes, other insertion is also painful or difficult', 'r:persistent_insertion_pain'),
        choice('No, it seems specific to this sponge', 'r:product_discomfort'),
        choice('I am not sure', 'r:gentle_trial')
      ]),
      pain_wear: question('What does the discomfort feel like?', 'A correctly fitted sponge should not cause significant pain or pressure.', [
        choice('Pressure, fullness or it feels too large', 'r:pressure'),
        choice('Burning, stinging or itching', 'r:irritation'),
        choice('Pelvic cramping or deep pain', 'r:product_discomfort'),
        choice('Urinary difficulty or severe pain', 'r:urgent_help')
      ]),
      care_type: question('Which type of sponge do you have?', 'Do not apply reusable sea-sponge care to a disposable synthetic sponge.', [
        choice('A reusable natural sea sponge', 'sea_care'),
        choice('A single-use synthetic sponge', 'single_care'),
        choice('I am not sure', 'r:type_check')
      ]),
      sea_care: question('What would you like help with?', 'Care methods vary by brand, including whether mild soap, boiling or a particular soak is permitted.', [
        choice('Routine cleaning and sanitising', 'r:sea_cleaning'),
        choice('Drying and storage', 'r:drying'),
        choice('A persistent odour', 'r:sea_odour'),
        choice('Staining or discolouration', 'r:sea_stain'),
        choice('Boiling, vinegar, bicarbonate or another cleaning method', 'r:care_instructions'),
        choice('When to replace it', 'r:replace_sea'),
        choice('Maximum wear time or overnight use', 'r:wear_time')
      ]),
      single_care: question('What would you like help with?', 'A product labelled single-use must be discarded after removal.', [
        choice('Can I wash and reuse it?', 'r:single_use'),
        choice('How should I dispose of it?', 'r:dispose_single'),
        choice('The wrapper is open, wet or damaged', 'r:discard_single'),
        choice('Maximum wear time or overnight use', 'r:wear_time'),
        choice('Can I use it during penetrative sex?', 'sex_type')
      ]),
      sex_type: question('Which sponge are you considering for penetrative sex?', 'Only use a sponge during sex if the instructions for that exact product specifically permit it.', [
        choice('A reusable natural sea sponge', 'r:sea_not_for_sex'),
        choice('A single-use sponge designed for period sex', 'sex_problem'),
        choice('A single-use sponge, but I am not sure it is designed for sex', 'r:sex_instructions'),
        choice('I am not sure what type it is', 'r:sex_instructions')
      ]),
      sex_problem: question('What is happening during or after sex?', 'Stop if either person experiences pain or significant discomfort.', [
        choice('The sponge moves or leaks', 'r:sex_movement'),
        choice('It is difficult to remove afterwards', 'r:sex_removal'),
        choice('My partner can feel it', 'r:partner_feels'),
        choice('It causes pain or irritation', 'r:sex_pain'),
        choice('I want to know about contraception or STI protection', 'r:sex_protection')
      ]),
      damage_type: question('Which description best matches?', 'Stop using a sponge that is damaged, deteriorating or cannot be checked properly.', [
        choice('My reusable sea sponge is tearing or shedding pieces', 'r:replace_sea'),
        choice('My reusable sponge has hardened or changed texture', 'r:replace_sea'),
        choice('My reusable sponge has a persistent odour', 'r:sea_odour'),
        choice('A single-use sponge has damaged packaging', 'r:discard_single'),
        choice('Part of a sponge may still be inside me', 'r:retained_piece')
      ])
    };

    const results = {
      residual: result('This may be residual blood rather than an ongoing leak', 'A small amount of blood can remain below the sponge after insertion and appear as spotting even when the sponge is absorbing normally.', 'If the spotting stops and the sponge contains menstrual fluid on removal, the sponge may be working correctly.', [
        'After inserting the sponge, wipe away any blood around the vaginal opening with clean toilet paper or a damp cloth.',
        'Use external backup protection while testing if that helps you feel more confident.',
        'If spotting becomes an ongoing flow, restart this tool and choose the timing that best matches.'
      ], ['Technique check', 'Observe first'], link('Read about menstrual sponges', paths.overview), null, '', false, 'Most likely'),
      saturated: result('The sponge may be saturated', 'A sponge that begins leaking after some time, during heavy flow or with abdominal pressure may have reached its usable absorbency.', 'Sponge absorbency is not standardised across brands, and even a large sponge may need frequent changes on a heavy day.', [
        'Remove or change the sponge sooner, without exceeding its product-specific wear time.',
        'Check whether it is saturated when removed and note the reliable interval for that day of your cycle.',
        'For a reusable sea sponge, clean it exactly as directed before reinsertion; discard a single-use sponge.',
        'Compare size and product type if the safe interval is impractical for you.'
      ], ['Saturation', 'Change sooner', 'Flow varies'], link('Compare menstrual sponges', paths.comparison), link('Browse menstrual sponges', paths.products), 'If you regularly need to change a period product every 1–2 hours, bleed through clothing or bedding, or feel dizzy, breathless or unusually fatigued, speak with a healthcare professional.', true, 'Likely explanation'),
      not_high_enough: result('The sponge may need to sit further inside', 'A sponge that remains near the vaginal opening can feel noticeable, move down or allow fluid to pass around it.', 'The sponge should sit fully inside the vaginal canal, above the pelvic floor muscles, without causing pain.', [
        'Wash and dry your hands and prepare the sponge exactly as its instructions direct.',
        'Choose a comfortable position, relax your pelvic floor and angle the sponge back towards your tailbone.',
        'Use a clean finger to guide it fully inside rather than leaving it at the opening.',
        'Stop if you meet pain or strong resistance.'
      ], ['Placement', 'Insertion angle', 'Do not force'], link('See sea-sponge insertion steps', paths.howToSea), null, '', false, 'Technique adjustment'),
      observe_leak: result('Check timing, position and saturation before changing products', 'The most useful clues are when leaking begins, whether the sponge stays fully inside and how saturated it is on removal.', 'Changing several things at once makes it harder to identify placement, flow or product fit.', [
        'Use external backup protection for one wear test.',
        'Note the insertion time and when leaking begins.',
        'Notice whether the sponge moves towards the opening during wear.',
        'On removal, check whether it is lightly used, partly saturated or fully saturated.'
      ], ['Observe first', 'Timing', 'Position', 'Saturation'], link('Read about menstrual sponges', paths.overview), null, '', false, 'Best next step'),
      sea_fit_capacity: result('Review the sea sponge’s size, shape and condition', 'A reusable sea sponge that leaks while secure and not saturated may not be making reliable contact with your anatomy, or its shape may have changed.', 'Natural sponges vary in shape and density, so a size label alone does not predict fit or absorbency.', [
        'Check that the sponge is fully inside and inspect it for thin areas, tears or loss of bounce.',
        'If your manufacturer permits trimming, make only small edge adjustments; do not cut it in half.',
        'Consider another intact sponge, size or shape if correct placement does not solve the leak.',
        'Change one factor at a time and use backup protection while testing.'
      ], ['Natural variation', 'Size and shape', 'Inspect condition'], link('Compare reusable sponges', paths.comparison), link('Browse reusable sponges', paths.reusable), '', false, 'Possible fit issue'),
      single_fit_capacity: result('This single-use sponge may not suit your flow or anatomy', 'A manufactured sponge can still allow bypass leaking if its shape, dimensions or absorbency do not suit your body and flow.', 'Single-use sponges cannot be trimmed, washed or reused to adjust their fit.', [
        'Confirm that it is inserted fully and has not become saturated.',
        'Check the product instructions for the correct preparation and orientation.',
        'Compare the actual dimensions, design and removal feature of another size or product.',
        'Discard the used sponge and use a new one for any further test.'
      ], ['Single-use', 'Dimensions', 'Absorbency'], link('Compare menstrual sponges', paths.comparison), link('Browse single-use sponges', paths.disposable), '', false, 'Possible product mismatch'),
      type_check: result('Check whether your sponge is reusable or single-use', 'Care, preparation, wear time and disposal depend on the exact product.', 'A synthetic sponge labelled single-use must never be washed and reused, while a reusable sea sponge needs brand-specific cleaning and complete drying.', [
        'Find the product name on its packet, receipt or order confirmation.',
        'Check whether it says reusable natural sea sponge or single-use synthetic sponge.',
        'Read the supplied instructions before preparing, cleaning or reinserting it.',
        'Contact Period Shop with the product name if you are still unsure.'
      ], ['Identify the product', 'Instructions matter', 'Do not guess'], link('Compare sponge types', paths.comparison), link('Contact Period Shop', paths.contact), '', false, 'Product type first'),
      damp_prepare: result('Wet and compress the sea sponge as directed', 'A natural sea sponge is firm when dry and usually becomes soft and compressible after it absorbs clean water.', 'Insertion is more difficult if it is dry, dripping wet or not compressed into a narrow shape.', [
        'Wash and dry your hands.',
        'Wet the sponge with clean water, then squeeze out the excess so it is damp rather than dripping.',
        'Compress or gently twist it into a narrow shape and insert it before it expands.',
        'Follow your brand instructions if they specify a different preparation method.'
      ], ['Dampen', 'Squeeze', 'Compress'], link('Follow the sea-sponge guide', paths.howToSea), null, '', false, 'Preparation adjustment'),
      trim_or_size: result('Make only product-approved size adjustments', 'Some reusable sea sponges may be trimmed around the edges, but not every product uses the same instructions.', 'Large cuts or thin sections can make a sponge tear, shed pieces or lose useful absorbency.', [
        'Check that your manufacturer permits trimming before cutting anything.',
        'If allowed, use clean, sharp scissors and remove only a small amount from an edge.',
        'Do not cut the sponge in half and avoid creating thin sections.',
        'Inspect and prepare it again as directed, or choose a smaller sponge instead.'
      ], ['Check instructions', 'Small edge changes', 'Avoid thin areas'], link('Read the trimming guidance', paths.howToSea), link('Compare reusable sizes', paths.comparison), '', false, 'Size adjustment'),
      placement_basics: result('Relax, compress and angle the sponge back', 'A sponge is inserted into the vaginal canal rather than pushed straight upwards.', 'Body position and pelvic-floor relaxation can make more difference than force.', [
        'Try sitting, squatting or standing with one foot raised.',
        'Prepare the exact sponge as its instructions direct and compress it into a narrow shape.',
        'Angle it back towards your tailbone and guide it fully inside with a clean finger.',
        'Pause and try another time if your muscles tighten or insertion becomes painful.'
      ], ['Body position', 'Backwards angle', 'Relax'], link('Read the sponge guide', paths.overview), null, '', false, 'Technique adjustment'),
      single_instructions: result('Check the instructions for the wet or dry version', 'Pre-moistened and dry single-use sponges may use different preparation methods.', 'Adding water, cleanser or lubricant without checking can change the product or expose you to an unsuitable ingredient.', [
        'Confirm the product name and whether it is the wet or dry version.',
        'Follow only the preparation method on its packet or manufacturer instructions.',
        'If lubricant is permitted, use the stated type and amount rather than improvising.',
        'Stop if insertion causes burning, stinging or pain.'
      ], ['Wet or dry version', 'Packet instructions', 'Stop with irritation'], link('Compare single-use sponges', paths.comparison), link('Contact Period Shop', paths.contact), '', false, 'Check the packet'),
      single_size: result('A different manufactured size or shape may be easier', 'Single-use sponges have fixed dimensions and should not be cut or reshaped.', 'A product that feels too bulky may not suit your anatomy even if its size name sounds appropriate.', [
        'Do not trim or tear the sponge.',
        'Check that you have compressed and oriented it as directed.',
        'Compare actual dimensions and removal design rather than relying only on Mini, Normal or another label.',
        'Stop using it if the same pressure or pain returns.'
      ], ['Fixed dimensions', 'Do not trim', 'Compare designs'], link('Compare single-use sponges', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible size issue'),
      irritation: result('Remove the sponge and stop this trial', 'Burning, stinging, itching or irritation can relate to friction, a product ingredient, residue, cleaning or another vaginal-health issue.', 'Continuing through irritation can make it worse and this tool cannot identify the medical cause.', [
        'Remove the sponge gently and do not reinsert it while symptoms are present.',
        'For a reusable sponge, review whether it was cleaned, rinsed and dried exactly as directed.',
        'For a single-use wet sponge, note the product and its gel or ingredients.',
        'Seek healthcare advice if symptoms are significant, persist or recur.'
      ], ['Remove', 'Stop use', 'Review product'], link('Read about sponge care', paths.overview), null, 'Seek prompt medical advice for irritation with unusual discharge, unpleasant vaginal odour, pelvic pain, fever, sores or urinary symptoms.', true, 'Stop using the sponge'),
      persistent_insertion_pain: result('Pain with other insertion deserves individual support', 'If tampons, a clean finger, penetrative sex or pelvic examinations are also painful, the problem may not be the sponge alone.', 'Pelvic-floor muscle tension, dryness, irritation and other conditions can contribute, but a decision tree cannot diagnose the cause.', [
        'Stop the insertion attempt rather than pushing through pain.',
        'Wait until any soreness has settled before trying another internal product.',
        'Consider speaking with a GP, sexual-health clinician or pelvic-health physiotherapist.',
        'Seek prompt advice if pain is severe, new or accompanied by bleeding, discharge, fever or urinary symptoms.'
      ], ['Do not force', 'Pelvic-health support', 'Individual assessment'], link('Find a pelvic-health physiotherapist', paths.physio), null, '', true, 'Pause and seek support'),
      fit_stability: result('Review placement, saturation and sponge dimensions', 'A sponge that moves during normal activity may be too low, saturated or not stable for your anatomy.', 'The right product should stay fully inside without significant pressure or pain.', [
        'Check that the sponge is inserted fully and has not reached saturation before activity.',
        'Note whether it moves only with a full bladder, bowel movement, coughing or particular exercise.',
        'Compare another size, shape or product type if correct placement and earlier changing do not solve it.',
        'Stop if a larger or firmer option causes pressure, pain or urinary difficulty.'
      ], ['Placement', 'Saturation', 'Dimensions'], link('Compare menstrual sponges', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', false, 'Possible fit issue'),
      urgent_help: result('Stop using the sponge and seek urgent medical care', 'Severe pain, inability to urinate or symptoms that could indicate toxic shock syndrome are not ordinary fit problems.', 'Toxic shock syndrome is rare but can progress quickly and requires urgent hospital assessment.', [
        'If you think you may have toxic shock syndrome, call 000 or go to the nearest emergency department.',
        'Remove the sponge if you can do so safely and without delaying help.',
        'Do not use tools or keep forcing removal if it is stuck or painful.',
        'Tell the clinician what product you used and how long it may have been in place.'
      ], ['Urgent care', 'Call 000', 'Do not force'], link('Read Healthdirect TSS guidance', paths.tss), link('Read retained-object guidance', paths.retained), '', true, 'Urgent'),
      stuck_calm: result('Relax, bear down gently and try once more', 'A sponge cannot travel through the cervix, but it can move higher in the vaginal canal and become difficult to reach.', 'Squatting and gentle bearing down can shorten the canal and bring the sponge closer.', [
        'Wash and dry your hands, then sit on the toilet or squat somewhere safe.',
        'Breathe slowly, relax your jaw and pelvic floor, and bear down gently as if having a bowel movement.',
        'Use clean fingers to locate and grasp the sponge or its finger slit, then ease it out slowly.',
        'Stop repeated attempts if you cannot remove it easily, removal is painful or you are causing injury.'
      ], ['Stay calm', 'Squat', 'Bear down gently'], link('Read Healthdirect retained-object guidance', paths.retained), link('Contact Period Shop', paths.contact), 'Arrange prompt medical help if you cannot remove it. Do not use tweezers, scissors or another tool inside the vagina.', true, 'Try gently, then seek help'),
      retained_piece: result('Seek medical help if part of the sponge may remain inside', 'A torn sponge or missing fragment should be treated like a possible retained vaginal object.', 'A clinician can check and remove retained material safely; probing with tools can cause injury.', [
        'Do not insert another sponge or internal period product.',
        'Do not use tweezers, scissors or another tool inside the vagina.',
        'Keep the removed sponge or packaging so you can explain what is missing.',
        'Contact a doctor, practice nurse or sexual-health clinic for assessment.'
      ], ['Possible retained material', 'No tools', 'Medical assessment'], link('Read Healthdirect retained-object guidance', paths.retained), null, 'Seek urgent care if you also have severe pain, fever, vomiting, dizziness, rash, abnormal discharge or feel seriously unwell.', true, 'Stop using the sponge'),
      removal_feature: result('Use the product’s removal feature as a finger grip', 'A finger slit or pull tab helps you locate and grip some synthetic sponges, but it is not a long tampon string.', 'Natural sea sponges and some single-use products have no built-in removal aid.', [
        'Wash and dry your hands, squat or sit on the toilet and relax your pelvic floor.',
        'Bear down gently until you can reach the sponge.',
        'Hook a clean finger into the slit or around the sponge and ease it out slowly.',
        'If you cannot reach it after a calm attempt, seek help rather than using tools.'
      ], ['Finger grip', 'Squat', 'No tools'], link('Compare removal features', paths.comparison), link('Read retained-object guidance', paths.retained), '', false, 'Removal technique'),
      removal_pain: result('Do not keep pulling through pain', 'Dryness, muscle tension, gripping a small area or removing a relatively dry sponge can make removal uncomfortable.', 'Severe or persistent pain is not something to solve with force.', [
        'Pause, breathe slowly and relax your pelvic floor before trying again.',
        'Bear down gently and grasp as much of the sponge as you comfortably can.',
        'Ease it out slowly rather than pulling sharply on one edge or a small piece.',
        'Seek help if removal remains painful or you cannot remove it without injury.'
      ], ['Pause', 'Relax', 'Gentle removal'], link('Read the removal guide', paths.howToSea), link('Read retained-object guidance', paths.retained), 'Seek healthcare advice if pain persists after removal, recurs with insertion or occurs with bleeding, discharge, fever or urinary symptoms.', true, 'Do not force removal'),
      messy_removal: result('Plan removal around saturation and access to a sink', 'Sponges absorb rather than collect fluid, so removal can be more hands-on than removing a cup, disc or tampon with a string.', 'A very saturated sponge is also more likely to drip or compress during removal.', [
        'Change the sponge before it becomes completely saturated.',
        'Remove it in the shower or near a sink when practical.',
        'Keep the sponge level and grasp a broad area as you ease it out.',
        'Have toilet paper or a clean cloth ready, then clean or discard the sponge as directed.'
      ], ['Change sooner', 'Near a sink', 'Hands-on removal'], link('Read the sponge guide', paths.overview), null, '', false, 'Practical adjustment'),
      pressure: result('This sponge may be too large, too low or unsuitable for you', 'A sponge should not cause ongoing pressure, fullness or awareness during wear.', 'Natural size labels are not standardised, and manufactured sponges have fixed dimensions.', [
        'Remove the sponge and check whether the pressure settles.',
        'On one gentle retry, make sure it is fully inserted rather than sitting near the opening.',
        'For a reusable sea sponge, consider a smaller size or only manufacturer-approved edge trimming.',
        'For a single-use sponge, compare a different manufactured size or shape; do not trim it.'
      ], ['Size', 'Position', 'Product type'], link('Compare menstrual sponges', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), 'Seek healthcare advice if pressure or pain persists after removal, or if you have urinary difficulty.', true, 'Remove and reassess'),
      product_discomfort: result('This product may not suit your body or may need a technique review', 'Pain that occurs only with this sponge can relate to its size, shape, texture, preparation or position.', 'It should not require repeated painful trials to make it work.', [
        'Remove the sponge and let any soreness settle.',
        'Check that it was prepared and inserted exactly as directed.',
        'Compare its actual dimensions, texture and material with another option.',
        'Stop using it and seek advice if pain returns or persists after removal.'
      ], ['Size and shape', 'Preparation', 'Do not push through pain'], link('Compare menstrual sponges', paths.comparison), link('Take the Best Fit Quiz', paths.quiz), '', true, 'Possible product mismatch'),
      gentle_trial: result('Use a shorter, gentle trial to gather one clear clue', 'When the cause is unclear, a controlled test can help without committing to a full wear period.', 'The goal is comfort and correct technique, not pushing through resistance.', [
        'Wait until any soreness has settled and read the exact product instructions again.',
        'Prepare the sponge as directed and try a relaxed position with plenty of time.',
        'Stop immediately if you feel pain, burning or strong resistance.',
        'If difficulty continues, choose an external product for now and seek individual advice.'
      ], ['Short trial', 'Stop with pain', 'One change at a time'], link('Read about menstrual sponges', paths.overview), link('Contact Period Shop', paths.contact), '', false, 'Gentle next step'),
      irritation_signs: result('Remove the sponge and arrange healthcare advice', 'Itching, unusual discharge, an unpleasant vaginal smell, pelvic pain or urinary symptoms can indicate irritation, infection or a retained object.', 'A troubleshooting tool cannot determine the cause, and continuing internal use may make assessment harder.', [
        'Remove the sponge if you can do so easily and do not insert another one.',
        'Seek advice from a doctor, practice nurse or sexual-health clinic.',
        'Mention the product, cleaning method and how long it was worn.',
        'Seek urgent care if you also have TSS symptoms or feel seriously unwell.'
      ], ['Stop use', 'Healthcare advice', 'Check for retained material'], link('Read Healthdirect retained-object guidance', paths.retained), link('Read TSS symptoms', paths.tss), '', true, 'Medical advice recommended'),
      sea_cleaning: result('Use the care method for your exact sea sponge', 'Sea-sponge cleaning and sanitising instructions vary between brands.', 'A cup-cleaning method or another sponge brand’s soak can shrink, toughen or leave residue in your sponge.', [
        'Follow the cleaning and sanitising instructions supplied with the sponge.',
        'Rinse thoroughly with clean water and use only a cleanser or soak the manufacturer permits.',
        'Avoid fragrances, essential oils and harsh chemicals unless the manufacturer specifically approves them.',
        'Allow the sponge to dry completely before storing it.'
      ], ['Brand-specific care', 'Rinse thoroughly', 'Dry completely'], link('Read sea-sponge care guidance', paths.howToSea), null, '', false, 'Care instructions matter'),
      drying: result('Let the sponge dry completely before storage', 'Moisture trapped in an airtight container can encourage microbial growth and odour.', 'A reusable sea sponge needs airflow between uses as well as correct cleaning.', [
        'Rinse and clean the sponge exactly as directed.',
        'Gently squeeze out excess water without damaging the fibres.',
        'Air-dry it completely in a clean, well-ventilated place.',
        'Store it dry in the supplied pouch or another clean, breathable place, not sealed damp in plastic.'
      ], ['Air-dry', 'Breathable storage', 'No trapped moisture'], link('Read sea-sponge storage guidance', paths.howToSea), null, '', false, 'Dry fully'),
      sea_odour: result('Stop using the sponge while you clean and inspect it', 'A persistent odour can be a sign that the sponge was not fully cleaned or dried, or that it is deteriorating.', 'An odour limited to the sponge is different from a new unpleasant vaginal smell or unusual discharge.', [
        'Clean and sanitise it only by the method approved for that product.',
        'Rinse thoroughly and let it dry completely.',
        'Inspect for tears, loose pieces, hardened areas or loss of bounce.',
        'Replace it if the odour persists after correct care or its condition has changed.'
      ], ['Clean', 'Dry', 'Inspect', 'Replace if persistent'], link('Read sea-sponge care guidance', paths.howToSea), null, 'Seek healthcare advice if the odour seems vaginal or occurs with discharge, itching, pelvic pain, fever or urinary symptoms.', true, 'Clean and inspect'),
      sea_stain: result('Discolouration alone may be cosmetic', 'Natural sea sponges can change colour over time, but colour is only one part of a condition check.', 'Odour, loose pieces, tears, hardening and difficulty cleaning are stronger reasons to replace it.', [
        'Clean and sanitise the sponge exactly as its manufacturer directs.',
        'Inspect it in good light after cleaning and drying.',
        'Do not use unapproved bleach, fragrance or harsh stain treatments.',
        'Replace it if staining occurs with deterioration, persistent odour or an inability to clean it properly.'
      ], ['Condition check', 'Product-approved care', 'Inspect after drying'], link('Read when to replace a sponge', paths.howToSea), null, '', false, 'Usually a condition check'),
      care_instructions: result('Do not combine cleaning methods from different brands', 'Some manufacturers permit a particular soak or advise against boiling, while another product may have different care instructions.', 'Natural sponge fibres can shrink, toughen or deteriorate when treated incorrectly.', [
        'Find the cleaning instructions supplied with your exact sponge.',
        'Use only the stated concentration, water temperature and contact time.',
        'Do not add vinegar, bicarbonate, essential oils, fragrance, harsh chemicals or boiling unless that manufacturer permits it.',
        'Contact Period Shop before improvising if the instructions are missing.'
      ], ['Do not mix methods', 'Exact concentration', 'Exact timing'], link('Read sea-sponge care guidance', paths.howToSea), link('Contact Period Shop', paths.contact), '', false, 'Check before cleaning'),
      replace_sea: result('Stop using a deteriorating sea sponge', 'Loose pieces, tears, thin areas, hardening, loss of bounce, persistent odour or difficulty cleaning are reasons to replace it.', 'A damaged sponge may shed material, perform poorly or be harder to clean thoroughly.', [
        'Stop using the sponge and inspect it in good light while clean and wet, then again when dry.',
        'Do not glue, stitch or repair it, and do not cut away large damaged sections.',
        'Follow the manufacturer’s replacement interval, but replace it sooner if its condition requires it.',
        'Seek medical help if you think a piece may remain inside you.'
      ], ['Replace', 'Do not repair', 'Check for missing pieces'], link('Read replacement guidance', paths.howToSea), link('Browse reusable sponges', paths.reusable), '', false, 'Stop using this sponge'),
      single_use: result('Do not wash or reuse a single-use sponge', 'Synthetic sponges such as Beppy and Joy Division products are designed for one use and disposal.', 'Washing does not make them reusable and may damage the foam or introduce contamination.', [
        'Use each sponge once and follow its maximum wear time.',
        'Remove it using the supplied instructions.',
        'Place it in the rubbish after use; do not flush it.',
        'Choose a purpose-designed reusable product if reusability is important to you.'
      ], ['Single-use', 'Do not wash', 'Do not flush'], link('Browse reusable sponges', paths.reusable), link('Compare sponge types', paths.comparison), '', false, 'Use once only'),
      dispose_single: result('Place the used sponge in the rubbish', 'Single-use synthetic sponges and their wrappers are not designed to be flushed.', 'Flushing can contribute to plumbing and wastewater problems.', [
        'Remove the sponge according to its instructions.',
        'Wrap it in toilet paper or its wrapper if you prefer.',
        'Place it in a general-waste bin.',
        'Wash and dry your hands afterwards.'
      ], ['General waste', 'Do not flush', 'Wash hands'], link('Read about single-use sponges', paths.comparison), null, '', false, 'After removal'),
      discard_single: result('Do not use a single-use sponge with damaged packaging', 'Individual packaging helps protect the product before use.', 'If the wrapper is open, wet, punctured or otherwise compromised, you cannot rely on the product being in its intended condition.', [
        'Set the damaged sponge aside and do not insert it.',
        'Use another sponge from an intact wrapper.',
        'Keep the packaging and batch details if you plan to contact Period Shop.',
        'Discard the damaged item as directed; do not wash it for use.'
      ], ['Do not insert', 'Intact wrapper', 'Single-use'], link('Contact Period Shop', paths.contact), null, '', false, 'Use another sponge'),
      wear_time: result('Follow the maximum wear time for your exact sponge', 'Wear-time instructions vary considerably between sponge brands and products.', 'A generic rule may be wrong: current Period Shop guidance ranges from around 3–4 hours for some sea sponges to a maximum of 8 hours for some other sea and synthetic sponges.', [
        'Check the packaging, product page or instructions for your exact brand and model.',
        'Remove or change it sooner if it becomes saturated, leaks, feels uncomfortable or causes irritation.',
        'Do not exceed the stated maximum even when your flow is light.',
        'Do not assume it is suitable for overnight wear; some brands specifically advise against it.'
      ], ['Product-specific limit', 'Change sooner if needed', 'Check overnight use'], link('Compare sponge wear times', paths.comparison), null, 'Remove the sponge and seek urgent medical care if you develop symptoms that could indicate toxic shock syndrome.', true, 'Check your instructions'),
      sea_not_for_sex: result('Do not use a reusable sea sponge during intercourse', 'Period Shop’s current guidance advises against using reusable natural sea sponges during penetrative sex.', 'Penetration can move a sponge higher and make it harder to remove, and a reusable sponge is not automatically designed or tested for this use.', [
        'Remove the reusable sea sponge before penetrative sex.',
        'If you want an internal product for period sex, compare a single-use sponge specifically designed for that purpose.',
        'Follow its insertion, wear-time and removal instructions.',
        'Remember that no menstrual sponge is contraception or STI protection.'
      ], ['Reusable sea sponge', 'Remove before sex', 'Choose a purpose-designed product'], link('Browse sponges designed for period sex', paths.disposable), link('Read period-sex guidance', paths.periodSex), '', false, 'Choose another option'),
      sex_instructions: result('Check that the exact sponge is designed for penetrative sex', 'Some single-use synthetic sponges are marketed for use during intercourse, but this should never be assumed from a stringless shape alone.', 'Product instructions take priority because materials, shapes, removal features and wear times differ.', [
        'Find the brand and model on the packet.',
        'Do not use it during sex unless its instructions specifically permit this use.',
        'Read how it should be positioned and removed afterwards.',
        'Use appropriate contraception and STI protection when needed.'
      ], ['Check instructions', 'Designed use only', 'Not contraception'], link('Compare menstrual sponges', paths.comparison), link('Read period-sex guidance', paths.periodSex), '', false, 'Check first'),
      sex_movement: result('Insertion depth, saturation or product fit may be contributing', 'Penetration can compress or move a sponge, particularly if it is low, saturated or not a suitable size for your anatomy.', 'Even a product designed for period sex may not suit every body or position.', [
        'Confirm that the product instructions permit use during penetrative sex.',
        'Insert a new sponge as directed and make sure it sits fully inside before sex.',
        'Do not begin when it is already close to its wear-time limit or saturated.',
        'Stop and remove it if movement causes pain, persistent leaking or difficulty afterwards.'
      ], ['Purpose-designed product', 'Insert fully', 'Not saturated'], link('Compare sponges for period sex', paths.comparison), link('Browse single-use sponges', paths.disposable), 'A menstrual sponge is not contraception and does not protect against sexually transmitted infections.', false, 'Technique or fit'),
      sex_removal: result('Let the body relax before removal', 'A sponge can move higher during penetration and pelvic-floor muscles may remain tense immediately afterwards.', 'Squatting and gentle bearing down may bring it within reach; tools are not a safe shortcut.', [
        'Wait until penetration has stopped and you are comfortable and relaxed.',
        'Wash and dry your hands, then squat or sit on the toilet.',
        'Bear down gently and use the finger slit or grasp the sponge with clean fingers.',
        'Seek prompt medical help if you cannot remove it or removal is painful.'
      ], ['Relax first', 'Bear down', 'No tools'], link('Read retained-object guidance', paths.retained), link('Compare removal features', paths.comparison), '', true, 'Remove calmly'),
      partner_feels: result('A partner may notice the sponge or its position', 'Whether it can be felt depends on anatomy, insertion depth, sponge dimensions and the sexual position.', 'Being noticeable is not automatically harmful, but pain, rubbing or irritation means you should stop.', [
        'Confirm that the sponge is designed for use during penetrative sex.',
        'Check that it is inserted fully and positioned as its instructions describe.',
        'Try a comfortable position with less direct contact if both people want to continue.',
        'Remove the sponge if either person has pain or significant irritation.'
      ], ['Position', 'Dimensions', 'Comfort'], link('Compare sponges for period sex', paths.comparison), null, 'A menstrual sponge is not contraception and does not protect against sexually transmitted infections.', false, 'Often position-dependent'),
      sex_pain: result('Stop if the sponge causes pain during sex', 'Pain or irritation can relate to product position, size, texture, ingredients, friction or another pelvic-health factor.', 'Neither person should push through pain to keep using the sponge.', [
        'Stop penetration and remove the sponge gently if you can do so comfortably.',
        'Do not reinsert it while pain or irritation is present.',
        'Check whether the exact product is designed for penetrative sex.',
        'Seek professional advice if pain persists, recurs or also occurs without the sponge.'
      ], ['Stop with pain', 'Remove gently', 'Pelvic-health support'], link('Find a pelvic-health physiotherapist', paths.physio), null, 'Seek prompt medical advice for significant pain, unexplained bleeding, unusual discharge, sores, fever or urinary symptoms.', true, 'Stop and reassess'),
      sex_protection: result('A menstrual sponge is not contraception or STI protection', 'A sponge may absorb menstrual fluid during sex, but it does not prevent pregnancy and does not protect against sexually transmitted infections.', 'Its position and absorbent material do not create a contraceptive barrier.', [
        'Use an appropriate contraceptive method if pregnancy prevention is needed.',
        'Use appropriate barrier protection to reduce STI transmission when needed.',
        'Check compatibility between the sponge, condoms, lubricant and any contraceptive product you use.',
        'Ask a pharmacist, doctor or sexual-health service if you are unsure about compatibility.'
      ], ['Not contraception', 'No STI protection', 'Check compatibility'], link('Read period-sex guidance', paths.periodSex), null, '', true, 'Important'),
      heavy_bleeding: result('The sponge may not provide enough absorbency for your flow', 'Sponges absorb menstrual fluid but do not treat the cause of heavy bleeding, and sponge absorbency is not standardised across brands.', 'Frequently saturating an internal product can make leaking and removal more difficult and may be a sign to discuss your bleeding with a clinician.', [
        'Use external backup protection and change the sponge sooner without exceeding its instructions.',
        'Record how often it saturates, how long bleeding lasts and whether you pass large clots or bleed through clothing or bedding.',
        'Consider a different product type if the required change interval is impractical.',
        'Speak with a healthcare professional about bleeding that is unusually heavy, prolonged or affecting everyday life.'
      ], ['Heavy flow', 'Track frequency', 'Healthcare advice'], link('Compare period products', paths.quiz), link('Contact Period Shop', paths.contact), 'Seek urgent care for very heavy bleeding with fainting, severe pain, shortness of breath, chest pain or feeling seriously unwell.', true, 'Flow may exceed absorbency'),
      safety_overview: result('Use sponge-specific precautions rather than assuming all sponges are alike', 'Evidence about menstrual sponges is limited, particularly for reusable natural sea sponges, and Australian regulatory options are still being considered.', 'This does not show that every sponge is unsafe. It means product quality, inspection, instructions, hygiene and symptom awareness matter.', [
        'Choose a purpose-made menstrual sponge from a reputable supplier and identify whether it is reusable or single-use.',
        'Wash and dry your hands and follow the exact preparation, wear-time, cleaning and replacement instructions.',
        'Never reuse a single-use sponge or use a damaged, deteriorating or persistently odorous reusable sponge.',
        'Remove it and seek urgent care if you develop symptoms that could indicate toxic shock syndrome.'
      ], ['Evidence is limited', 'Instructions matter', 'Know TSS symptoms'], link('Read the Period Shop safety overview', paths.comparison), link('Read Healthdirect TSS guidance', paths.tss), '', true, 'Evidence-informed guidance'),
      beginner: result('Learn preparation, insertion and removal as separate skills', 'Menstrual sponges can involve a learning curve, especially because many do not have a conventional string.', 'You do not need to perfect every step in one attempt or keep trying when sore or frustrated.', [
        'Identify whether your sponge is reusable natural or single-use synthetic.',
        'Read its full instructions before opening, wetting, trimming or inserting it.',
        'Practise the hand position for compressing and removing it before use.',
        'Use external backup protection and choose a shorter first trial while you are awake and near a bathroom.'
      ], ['Beginner', 'Product type', 'Short first trial'], link('Read about menstrual sponges', paths.overview), link('Take the Best Fit Quiz', paths.quiz), '', false, 'A good place to begin'),
      contact: result('Tell Period Shop what is happening', 'Some problems need more context than a decision tree can collect.', 'Useful details include the sponge brand and size, whether it is reusable or single-use, when the problem occurs and what you have already tried.', [
        'Note the brand, model, size and whether the sponge was wet, dry, natural or synthetic.',
        'Describe when the problem starts and what you find on removal.',
        'Include preparation, wear time, cleaning method and any discomfort.',
        'Do not send intimate photographs. Written details are enough to begin.'
      ], ['Individual guidance', 'Product details', 'What you tried'], link('Contact Period Shop', paths.contact), link('Compare menstrual sponges', paths.comparison), '', false, 'We can help')
    };

    const element = (tag, className = '', text = '') => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';
      const screen = root.querySelector('[data-tool-screen]');
      const back = root.querySelector('[data-back]');
      const restart = root.querySelector('[data-restart]');
      const progress = root.querySelector('.psst-progress');
      const progressBar = root.querySelector('[data-progress-bar]');
      const history = [];

      const setProgress = (value) => {
        progress.setAttribute('aria-valuenow', String(value));
        progressBar.style.width = `${value}%`;
      };

      const renderQuestion = (key) => {
        const item = questions[key];
        screen.replaceChildren();
        const wrapper = element('div', 'psst-question');
        wrapper.append(element('p', 'psst-result-kicker', history.length ? `Question ${history.length + 1}` : 'Start here'));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psst-question-copy', item.copy));
        const options = element('div', 'psst-options');

        item.choices.forEach((answer) => {
          const button = element('button', 'psst-option');
          button.type = 'button';
          button.append(element('strong', '', answer.label));
          if (answer.detail) button.append(element('span', '', answer.detail));
          button.addEventListener('click', () => {
            history.push(key);
            if (answer.next.startsWith('r:')) renderResult(answer.next.slice(2));
            else renderQuestion(answer.next);
          });
          options.append(button);
        });

        wrapper.append(options);
        screen.append(wrapper);
        back.hidden = history.length === 0;
        restart.hidden = history.length === 0;
        setProgress(Math.min(86, 20 + history.length * 18));
      };

      const renderResult = (key) => {
        const item = results[key];
        screen.replaceChildren();
        const wrapper = element('article', 'psst-result');
        wrapper.append(element('p', 'psst-result-kicker', item.kicker));
        wrapper.append(element('h2', '', item.title));
        wrapper.append(element('p', 'psst-result-summary', item.summary));
        wrapper.append(element('h3', '', 'Why this may be happening'));
        wrapper.append(element('p', 'psst-result-why', item.why));
        wrapper.append(element('h3', '', 'What to try next'));
        const steps = element('ol', 'psst-steps');
        item.steps.forEach((step) => steps.append(element('li', '', step)));
        wrapper.append(steps);

        if (item.note) {
          const note = element('p', 'psst-result-note', item.note);
          note.dataset.medical = item.medical ? 'true' : 'false';
          wrapper.append(note);
        }

        if (item.tags.length) {
          wrapper.append(element('h3', '', 'Factors to keep in mind'));
          const tags = element('div', 'psst-tags');
          item.tags.forEach((tag) => tags.append(element('span', 'psst-tag', tag)));
          wrapper.append(tags);
        }

        const actions = element('div', 'psst-actions');
        if (item.primary) {
          const primary = element('a', 'psst-cta psst-cta-primary', item.primary.label);
          primary.href = item.primary.url;
          actions.append(primary);
        }
        if (item.secondary) {
          const secondary = element('a', 'psst-cta psst-cta-secondary', item.secondary.label);
          secondary.href = item.secondary.url;
          actions.append(secondary);
        }
        wrapper.append(actions);
        screen.append(wrapper);
        back.hidden = false;
        restart.hidden = false;
        setProgress(100);
      };

      back.addEventListener('click', () => {
        const previous = history.pop();
        if (previous) renderQuestion(previous);
      });
      restart.addEventListener('click', () => {
        history.length = 0;
        renderQuestion('issue');
      });
      renderQuestion('issue');
    };

    document.querySelectorAll('[data-ps-sponge-tool]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ps-sponge-tool]').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
